(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"]) return;
  try {
    
  (function () {
    /**
     * Initialise 404 recovery funnel component to optimise customer engagement.
     */
    const initialise404 = () => {
      const pageEl = document.querySelector('.error-404:not([data-initialised="true"])');
      if (!pageEl) return;
      pageEl.setAttribute('data-initialised', 'true');

      const searchInput = pageEl.querySelector('[data-js="search-input"]');
      if (searchInput) {
        searchInput.focus();
      }

      const lazyLoadCards = (scope) => {
        const targets = [];
        scope.querySelectorAll('media-slider').forEach((slider) => {
          if (!slider.hasAttribute('data-loaded')) {
            targets.push(slider);
          }
        });
        if (targets.length === 0) return;
        const observer = new IntersectionObserver(
          (entries, obs) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const slider = entry.target;
                slider.setAttribute('data-loaded', 'true');
                if (typeof slider.loadActive === 'function') {
                  slider.loadActive();
                } else {
                  slider._loadActivePending = true;
                }
                obs.unobserve(slider);
              }
            });
          },
          { rootMargin: '200px 0px' }
        );
        targets.forEach((target) => observer.observe(target));
      };

      lazyLoadCards(pageEl);
    };

    document.addEventListener('DOMContentLoaded', initialise404);
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      initialise404();
    }
    document.addEventListener('shopify:section:load', initialise404);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-js="announcement-bar"]');
    if (!section) return;

    const slides = section.querySelectorAll('[data-js="announcement-slide"]');
    if (slides.length < 2) return;

    const ACTIVE_CLASS = 'is-active';
    const autoSlideEnabled = slides[0].dataset.autoSlide === 'true';
    const slideInterval = parseInt(slides[0].dataset.slideInterval, 10) || 3000;

    let currentSlide = 0;
    let intervalId = null;

    /**
     * Display the slide at the given index and update ARIA attributes.
     * @param {number} index - Zero-based slide index
     */
    const showSlide = (index) => {
      slides.forEach((slide, i) => {
        const isActive = i === index;
        slide.classList.toggle(ACTIVE_CLASS, isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
    };

    /** Advance to the next slide (wraps around). */
    const nextSlide = () => {
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
    };

    /** Start the auto-rotate interval. */
    const startAutoSlide = () => {
      if (intervalId !== null) return;
      intervalId = setInterval(nextSlide, slideInterval);
    };

    /** Stop the auto-rotate interval. */
    const stopAutoSlide = () => {
      if (intervalId === null) return;
      clearInterval(intervalId);
      intervalId = null;
    };

    /* ── Auto-slide with pause on hover & focus ──── */

    if (autoSlideEnabled && !window.themeUtils?.prefersReducedMotion) {
      startAutoSlide();

      section.addEventListener('mouseenter', stopAutoSlide);
      section.addEventListener('mouseleave', startAutoSlide);
      section.addEventListener('focusin', stopAutoSlide);
      section.addEventListener('focusout', startAutoSlide);
    }

    /* ── Emit hover event for header transparent state ── */

    section.addEventListener('mouseenter', () => {
      window.themeUtils?.emit('announcement:hover', { isHover: true });
    });

    section.addEventListener('mouseleave', () => {
      window.themeUtils?.emit('announcement:hover', { isHover: false });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /**
   * Cart page behaviour layer. Optimistic quantity/remove/size mutations are
   * batched through a single serialised write queue, then the page and the
   * minicart are refreshed from the Section Rendering API and reconciled by
   * `data-key` — no reloads, no Update button. Ported from the minicart's
   * cart engine (`sections/minicart.liquid`) — see
   * `docs/plans/cart-page-rebuild.md` (Stage B) for the research trail.
   *
   * One verified deviation from that plan doc, required for correct
   * behaviour on this branch (grepped, not assumed — AGENTS.md §1.8):
   *  - The Section Rendering API does not resolve a JSON template's local
   *    section key ("main" returns null) — the fetches below use the
   *    fully-qualified `section.id` Liquid renders onto `data-section-id`,
   *    and render in this page's URL context (template-scoped sections
   *    don't exist at `/`).
   *
   * @param {HTMLElement} root - The `[data-js="cart-page"]` element.
   * @returns {void}
   */
  function initialiseCartPage(root) {
    root.dataset.initialised = 'true';

    // ── Constants ────────────────────────────────────────────
    const PAGE_SECTION_ID = root.dataset.sectionId;
    const MINICART_SECTION_ID = 'minicart';
    const SECTIONS_TO_FETCH = `${PAGE_SECTION_ID},${MINICART_SECTION_ID}`;
    const DEBOUNCE_MS = 350;
    const FETCH_TIMEOUT_MS = 15000;
    const MONEY_PLACEHOLDER = /\x7b\x7b\s*(\w+)\s*\x7d\x7d/;

    const { prefersReducedMotion } = window.themeUtils || {};

    // ── State ────────────────────────────────────────────────
    /**
     * The LineOps registry — one live op per cart line with outstanding
     * work, keyed by line-item key (ported from sections/minicart.liquid's
     * engine core, §3.1). A row's visual busy state is a pure function of
     * its op (or absence): nothing may clear it except (a) its own batch
     * settling with generation === snapshotGeneration, (b) its own batch
     * failing (rollback), (c) reassertion after a reconcile.
     */
    const lineOps = new Map();
    /** One shared debounce timer for the whole quantity batch. */
    let quantityFlushTimer = null;
    /** Single serialised mutation chain — at most one cart write in flight. */
    let mutationChain = Promise.resolve();
    /** In-flight mutation counter (drives the checkout-busy guard). */
    let mutationInFlight = 0;
    let discountErrorTimer = null;
    let bannerDismissTimer = null;
    let refreshRequestToken = 0;
    /** Module counter stamping each quantity batch sent to the server. */
    let batchIdCounter = 0;

    // ── DOM helpers ──────────────────────────────────────────
    const getItemsList = () => root.querySelector('[data-cart-items]');
    const getLayout = () => root.querySelector('[data-cart-layout]');
    const getSummary = () => root.querySelector('[data-cart-summary]');
    const getEmptyState = () => root.querySelector('[data-cart-empty-state]');

    /**
     * Toggle a boolean data-attribute on an element.
     * @param {Element|null} el
     * @param {string} name
     * @param {boolean} on
     */
    const setBool = (el, name, on) => {
      if (!el) return;
      if (on) el.setAttribute(name, 'true');
      else el.removeAttribute(name);
    };

    // ── Money formatting (ported from sections/minicart.liquid) ──

    const addThousands = (intStr, sep) => intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);

    /**
     * Decode HTML entities / strip tags via DOMParser.
     * @param {string} str
     * @returns {string}
     */
    const decodeHtmlEntities = (str) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(str || '', 'text/html');
      return doc.documentElement.textContent;
    };

    /**
     * Format an amount in cents against the shop money format.
     * @param {number} cents
     * @returns {string}
     */
    const formatMoney = (cents) => {
      const fmt = root.dataset.moneyFormat || '\x7b\x7bamount\x7d\x7d';
      const value = cents / 100;
      const withDot = value.toFixed(2);
      const dotInt = withDot.split('.')[0];
      const dotFrac = withDot.split('.')[1];
      const noDec = Math.round(value).toString();
      const formats = {
        amount: `${addThousands(dotInt, ',')}.${dotFrac}`,
        amount_no_decimals: addThousands(noDec, ','),
        amount_with_comma_separator: `${addThousands(dotInt, '.')},${dotFrac}`,
        amount_no_decimals_with_comma_separator: addThousands(noDec, '.'),
        amount_with_space_separator: `${addThousands(dotInt, ' ')}.${dotFrac}`,
      };
      const match = fmt.match(MONEY_PLACEHOLDER);
      const key = match && formats[match[1]] !== undefined ? match[1] : 'amount';
      const text = fmt.replace(MONEY_PLACEHOLDER, formats[key]);
      return decodeHtmlEntities(text).trim();
    };

    // ── SR announcements ─────────────────────────────────────

    /**
     * Announce a message to the page's polite live region.
     * @param {string} msg
     */
    const announce = (msg) => {
      const sr = root.querySelector('[data-cart-sr-status]');
      if (!sr || !msg) return;
      sr.textContent = '';
      requestAnimationFrame(() => {
        sr.textContent = msg;
      });
    };

    // ── Banner + per-line errors ──────────────────────────────

    /**
     * Hide the page-level error banner (animated unless reduced motion).
     * @returns {void}
     */
    const hideBanner = () => {
      const banner = root.querySelector('[data-cart-banner]');
      if (!banner || banner.hidden) return;
      if (prefersReducedMotion) {
        banner.hidden = true;
        banner.removeAttribute('data-dismissing');
        return;
      }
      banner.setAttribute('data-dismissing', 'true');
      banner.addEventListener(
        'animationend',
        () => {
          banner.hidden = true;
          banner.removeAttribute('data-dismissing');
        },
        { once: true }
      );
    };

    /**
     * Show the page-level error banner, announce it, and auto-dismiss (~6s).
     * @param {string} [message]
     * @returns {void}
     */
    const showBannerError = (message) => {
      const banner = root.querySelector('[data-cart-banner]');
      const messageEl = banner?.querySelector('[data-cart-banner-message]');
      if (!banner || !messageEl || !message) return;
      const decodedMessage = decodeHtmlEntities(message);
      messageEl.textContent = decodedMessage;
      banner.hidden = false;
      banner.removeAttribute('data-dismissing');
      announce(decodedMessage);
      if (bannerDismissTimer) clearTimeout(bannerDismissTimer);
      bannerDismissTimer = setTimeout(hideBanner, 6000);
    };

    /**
     * Clear a stale error banner left by an earlier failed flush, now that a
     * later successful flush's own refresh has applied (§3.6, D8 — never at
     * flush start). Shared by runQuantityFlush, handleSizeSelectChange and
     * updateDiscountAndRefresh.
     * @returns {void}
     */
    const clearStaleBanner = () => {
      const banner = root.querySelector('[data-cart-banner]');
      if (banner && !banner.hidden) hideBanner();
    };

    /**
     * Show a per-line error under a cart item.
     * @param {string} lineKey
     * @param {string} [message]
     * @returns {void}
     */
    const showItemError = (lineKey, message) => {
      if (!message) return;
      const item = getItemsList()?.querySelector(`[data-js="cart-item"][data-key="${CSS.escape(lineKey)}"]`);
      const errorEl = item?.querySelector('[data-cart-item-error]');
      const messageEl = errorEl?.querySelector('[data-cart-item-error-message]');
      if (!errorEl || !messageEl) return;
      messageEl.textContent = decodeHtmlEntities(message);
      errorEl.hidden = false;
    };

    // ── Optimistic UI (LineOps engine, ported from sections/minicart.liquid) ──

    /**
     * Look up a line's live op by key, falling back to a variant-id match
     * (size ops carry the row's old/new variant id, not its line key).
     * @param {string} key
     * @param {string} [variantId]
     * @returns {Object|null}
     */
    const findOp = (key, variantId) => {
      if (key && lineOps.has(key)) return lineOps.get(key);
      if (!variantId) return null;
      for (const op of lineOps.values()) {
        if (op.targetVariantId === variantId || op.baseVariantId === variantId) return op;
      }
      return null;
    };

    /**
     * Restore a collapsed/collapsing row on rollback (§3.4, §4) — the
     * `--item-height` custom property set by animateItemRemoval() is reused
     * as the expand target so no re-measurement of a zero-height row is
     * needed.
     * @param {HTMLElement} row
     * @returns {void}
     */
    const restoreRemovedRow = (row) => {
      if (!row.dataset.removing && !row.dataset.collapsed) return; // nothing to restore
      delete row.dataset.collapsed;
      delete row.dataset.removing;
      if (prefersReducedMotion) {
        row.style.removeProperty('--item-height');
        return;
      }
      row.setAttribute('data-restoring', 'true');
      let fallback;
      const cleanup = () => {
        clearTimeout(fallback);
        row.removeAttribute('data-restoring');
        row.style.removeProperty('--item-height');
        row.removeEventListener('animationend', onRestoreEnd);
        row.removeEventListener('animationcancel', cleanup);
      };
      function onRestoreEnd(e) {
        if (e.animationName !== 'cart-item-expand') return;
        cleanup();
      }
      row.addEventListener('animationend', onRestoreEnd);
      row.addEventListener('animationcancel', cleanup);
      fallback = setTimeout(cleanup, 400); // above the ~320ms expand duration
    };

    /**
     * Reverse the optimistic items→empty transition (transitionToEmpty) on a
     * failed last-line removal — a no-op if that transition never fired.
     * @returns {void}
     */
    const reverseTransitionToEmpty = () => {
      const layout = getLayout();
      const empty = getEmptyState();
      if (!layout?.hidden) return; // never fired, or already reversed

      const reveal = () => {
        if (layout) layout.hidden = false;
      };

      if (!empty || empty.hidden || prefersReducedMotion) {
        if (empty) {
          empty.hidden = true;
          empty.removeAttribute('data-entering');
        }
        reveal();
        return;
      }

      if (empty.dataset.leaving) return; // already reversing — one pass is enough

      empty.removeAttribute('data-entering');
      empty.setAttribute('data-leaving', 'true');
      let fallback;
      const cleanup = () => {
        clearTimeout(fallback);
        empty.hidden = true;
        empty.removeAttribute('data-leaving');
        empty.removeEventListener('animationend', onLeaveEnd);
        empty.removeEventListener('animationcancel', cleanup);
        reveal();
      };
      function onLeaveEnd(e) {
        if (e.animationName !== 'cart-page-empty-out') return;
        cleanup();
      }
      empty.addEventListener('animationend', onLeaveEnd);
      empty.addEventListener('animationcancel', cleanup);
      fallback = setTimeout(cleanup, 350); // above the --motion-exit (190ms) duration
    };

    /**
     * Roll back one line's optimistic change on genuine failure (§3.4) — the
     * only other path (besides its own batch settling) allowed to clear a
     * row's busy visuals.
     * @param {Object} op - a lineOps entry
     * @returns {void}
     */
    const revertOptimisticUpdate = (op) => {
      const row = op?.rowEl;
      if (!row) return;

      if (op.kind === 'quantity') {
        const qtyInput = row.querySelector('[data-cart-quantity-input]');
        if (qtyInput) qtyInput.value = op.baseQty;
        row.querySelectorAll('[data-cart-quantity]').forEach((b) => {
          b.dataset.currentQty = op.baseQty;
        });
        delete row.dataset.pending;
        return;
      }

      if (op.kind === 'size') {
        const sel = row.querySelector('[data-cart-size-select]');
        if (sel && op.baseVariantId != null) sel.value = op.baseVariantId;
        delete row.dataset.pending;
        return;
      }

      // kind === 'remove' — restore the row with the expand animation (§4);
      // reverse the optimistic empty-state transition if it fired.
      restoreRemovedRow(row);
      reverseTransitionToEmpty();
    };

    /**
     * Optimistically apply a new quantity to a row ahead of the network.
     * @param {HTMLElement|null} itemEl
     * @param {number} newQty
     * @returns {void}
     */
    const applyOptimisticUpdate = (itemEl, newQty) => {
      if (!itemEl) return;
      const qtyInput = itemEl.querySelector('[data-cart-quantity-input]');
      if (qtyInput) qtyInput.value = newQty;
      itemEl.querySelectorAll('[data-cart-quantity]').forEach((b) => {
        b.dataset.currentQty = newQty;
      });
      itemEl.dataset.pending = 'true';
    };

    /**
     * Measure a row and start its removal collapse animation. Cleans up on
     * animationend/animationcancel + a timeout fallback (§4 interruptibility
     * rule) so an interrupted collapse never leaves a dangling listener.
     * @param {HTMLElement|null} itemEl
     * @returns {void}
     */
    const animateItemRemoval = (itemEl) => {
      if (!itemEl) return;
      const height = itemEl.offsetHeight; // measure before write (no layout thrash)
      itemEl.removeAttribute('data-fresh'); // clears a competing settle-fade (§4)
      itemEl.style.setProperty('--item-height', `${height}px`);
      itemEl.dataset.removing = 'true';
      if (prefersReducedMotion) return; // CSS[data-removing] hides it instantly
      let fallback;
      const cleanup = () => {
        clearTimeout(fallback);
        itemEl.removeEventListener('animationend', onCollapseEnd);
        itemEl.removeEventListener('animationcancel', cleanup);
      };
      function onCollapseEnd(e) {
        if (e.animationName !== 'cart-item-collapse') return;
        itemEl.dataset.collapsed = 'true';
        cleanup();
      }
      itemEl.addEventListener('animationend', onCollapseEnd);
      itemEl.addEventListener('animationcancel', cleanup);
      fallback = setTimeout(() => {
        itemEl.dataset.collapsed = 'true';
        cleanup();
      }, 400); // above the ~300ms collapse duration
    };

    /**
     * Apply/reassert a live op's visuals onto its row. Idempotent — safe to
     * call repeatedly (e.g. after every reconcile) without stacking effects.
     * @param {Object} op - a lineOps entry
     * @returns {void}
     */
    const applyOpVisuals = (op) => {
      const row = op?.rowEl;
      if (!row) return;
      if (op.kind === 'remove') {
        if (!row.dataset.removing) animateItemRemoval(row);
        return;
      }
      if (op.kind === 'quantity') {
        applyOptimisticUpdate(row, op.targetQty);
        return;
      }
      if (op.kind === 'size') {
        row.dataset.pending = 'true';
      }
    };

    /**
     * Re-resolve every live (non-settling) op's row by key — variant-id
     * fallback for size ops — and reassert its visuals. Called after every
     * reconcile (§3.5).
     * @returns {void}
     */
    const reassertOpVisuals = () => {
      const itemsList = getItemsList();
      if (!itemsList || lineOps.size === 0) return;
      lineOps.forEach((op) => {
        if (op.state === 'settling') return;
        let row = op.rowEl && op.rowEl.isConnected ? op.rowEl : null;
        if (!row) row = itemsList.querySelector(`[data-js="cart-item"][data-key="${CSS.escape(op.key)}"]`);
        if (!row) {
          const variantId = op.targetVariantId || op.baseVariantId;
          if (variantId) row = itemsList.querySelector(`[data-js="cart-item"][data-id="${CSS.escape(variantId)}"]`);
        }
        if (!row) return; // line genuinely gone — nothing to reassert
        op.rowEl = row;
        applyOpVisuals(op);
      });
    };

    /**
     * Relocate focus at removal-INTENT time (§5, T5 port) — before
     * animateItemRemoval()/transitionToEmpty() hide the row (or, last line,
     * the whole items list). No-op if focus isn't currently inside the row
     * (or, for the last line, the items list) about to disappear.
     * @param {HTMLElement} itemEl - the row being queued for removal
     * @param {boolean} isLastLine - true when transitionToEmpty() is about to
     *   hide the entire items list (no row survives to receive focus)
     * @returns {void}
     */
    const relocateFocusForRemoval = (itemEl, isLastLine) => {
      const active = document.activeElement;
      const scope = isLastLine ? itemEl?.closest('[data-cart-items]') || itemEl : itemEl;
      if (!active || !scope || !scope.contains(active)) return;

      if (!isLastLine) {
        const rows = [...(getItemsList()?.children || [])].filter((el) => el.dataset.js === 'cart-item');
        const index = rows.indexOf(itemEl);
        const isLive = (row) =>
          row && row !== itemEl && lineOps.get(row.dataset.key)?.kind !== 'remove' && !row.dataset.removing;
        const next = rows.slice(index + 1).find(isLive);
        const prev = [...rows.slice(0, Math.max(index, 0))].reverse().find(isLive);
        const target = next || prev;
        if (target) {
          const control = target.querySelector('[data-cart-remove]') || target;
          control.focus({ preventScroll: true });
          return;
        }
      }

      const emptyState = getEmptyState();
      const emptyLink = emptyState && !emptyState.hidden ? emptyState.querySelector('a, button') : null;
      if (emptyLink) {
        emptyLink.focus({ preventScroll: true });
        return;
      }

      const title = root.querySelector('.cart-page__title');
      if (title) title.focus({ preventScroll: true });
    };

    /**
     * Optimistically crossfade straight to the empty state on last-line
     * removal (§4) — reversed by reverseTransitionToEmpty() on failure.
     * @returns {void}
     */
    const transitionToEmpty = () => {
      const layout = getLayout();
      const empty = getEmptyState();
      if (layout) layout.hidden = true;
      if (empty) {
        empty.hidden = false;
        if (!prefersReducedMotion) {
          empty.setAttribute('data-entering', 'true');
          let fallback;
          const cleanup = () => {
            clearTimeout(fallback);
            empty.removeAttribute('data-entering');
            empty.removeEventListener('animationend', onEnterEnd);
            empty.removeEventListener('animationcancel', cleanup);
          };
          function onEnterEnd(e) {
            if (e.animationName !== 'cart-page-empty-in') return;
            cleanup();
          }
          empty.addEventListener('animationend', onEnterEnd);
          empty.addEventListener('animationcancel', cleanup);
          fallback = setTimeout(cleanup, 450); // above the 0.4s entering duration
        }
      }
    };

    // ── Sync / busy state ──────────────────────────────────────

    /** @returns {boolean} whether cart work is genuinely outstanding. */
    const isCartBusy = () => lineOps.size > 0 || mutationInFlight > 0;

    /**
     * Derive the shared busy chrome (totals + shop-pay-button dim, driven by the
     * existing `.cart-page[data-syncing]` CSS) from the registry + in-flight
     * mutation count (§3.3 port). The checkout buttons are never dimmed or
     * disabled by this (T3 port, §1 decision 4) — their own `[data-awaiting]`
     * state (set only by an actual checkout click) is the sole visual
     * feedback they show.
     * @returns {void}
     */
    const syncBusyUI = () => {
      setBool(root, 'data-syncing', isCartBusy());
    };

    // ── Cart API ───────────────────────────────────────────────

    /**
     * POST a cart endpoint with Section Rendering params, prefixed with the
     * storefront root (§11). Never throws (house catch idiom, §12.1).
     * @param {string} endpoint
     * @param {Object} body
     * @returns {Promise<Object>}
     */
    const cartFetch = async (endpoint, body) => {
      try {
        const res = await fetch(`${window.Shopify.routes.root}${endpoint}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            ...body,
            sections: SECTIONS_TO_FETCH,
            sections_url: window.location.pathname,
          }),
          signal: AbortSignal.timeout(FETCH_TIMEOUT_MS),
        });
        if (!res.ok) return { error: 'Network error', details: await res.text() };
        const data = await res.json();
        if (data?.status && data.status !== 200) {
          return { error: 'Shopify error', details: data.message || data.description, data };
        }
        return data;
      } catch (err) {
        // AbortSignal.timeout() raises a TimeoutError DOMException on the
        // signal firing; a manual abort would raise AbortError — treat both
        // as the same honest "took too long" sentinel (§3.6). Never throws.
        if (err.name === 'TimeoutError' || err.name === 'AbortError') return { error: 'Timeout error', timeout: true };
        return { error: 'Unexpected error', details: err };
      }
    };

    /**
     * Map a cartFetch error sentinel to a localised, user-facing message.
     * @param {Object|null} data
     * @returns {string}
     */
    const extractErrorMessage = (data) => {
      const generic = root.dataset.textUpdateError;
      if (!data || !data.error) return generic;
      if (data.error === 'Network error') return root.dataset.textErrorNetwork || generic;
      if (data.error === 'Timeout error') return root.dataset.textErrorTimeout || generic;
      if (data.error === 'Unexpected error') return root.dataset.textErrorGeneric || generic;
      const detailStr = String(data.details || '').trim();
      if (detailStr) {
        if (detailStr.startsWith('{') || detailStr.startsWith('[')) {
          try {
            const parsed = JSON.parse(detailStr);
            if (parsed?.message) return parsed.message;
          } catch {
            /* fall through */
          }
        } else {
          return detailStr;
        }
      }
      return root.dataset.textErrorGeneric || generic;
    };

    /**
     * Serialise a cart mutation onto the single chain — at most one cart
     * write is ever in flight.
     * @param {() => Promise<*>} run
     * @returns {Promise<*>}
     */
    const queueCartMutation = (run) => {
      mutationInFlight++;
      syncBusyUI();
      mutationChain = mutationChain.then(run, run).finally(() => {
        mutationInFlight--;
        syncBusyUI();
      });
      return mutationChain;
    };

    /**
     * Notify the minicart drawer of a settled cart-page mutation so it
     * refreshes itself in place — the canonical `cart:added` sync vehicle
     * (§11), tagged `source: 'cart-page'` so this page ignores its own echo.
     * @param {Object|null} [sections] - section HTML keyed by rendering id, when known.
     * @returns {void}
     */
    const syncMinicart = (sections) => {
      document.dispatchEvent(
        new CustomEvent('cart:added', {
          detail: {
            openMinicart: false,
            sections: sections?.[MINICART_SECTION_ID] ? { minicart: sections[MINICART_SECTION_ID] } : null,
            source: 'cart-page',
          },
        })
      );
    };

    // ── Line-item reconciliation ─────────────────────────────────

    /**
     * Drop a row once its collapse has finished (immediately when it
     * already has, or under reduced motion). Cleans up on
     * animationend/animationcancel + a timeout fallback (§4
     * interruptibility rule).
     * @param {HTMLElement} row
     * @returns {void}
     */
    const removeRowWhenCollapsed = (row) => {
      if (prefersReducedMotion || row.dataset.collapsed || row.offsetHeight === 0) {
        row.remove();
        return;
      }
      let fallback;
      const dispose = () => {
        clearTimeout(fallback);
        row.removeEventListener('animationend', onGone);
        row.removeEventListener('animationcancel', dispose);
        if (row.isConnected) row.remove();
      };
      function onGone(e) {
        if (e.animationName !== 'cart-item-collapse') return;
        dispose();
      }
      row.addEventListener('animationend', onGone);
      row.addEventListener('animationcancel', dispose);
      if (!row.dataset.removing) animateItemRemoval(row);
      fallback = setTimeout(dispose, 400); // above the ~300ms collapse duration
    };

    /**
     * Patch a live row's attributes/children from its fresh server render.
     * @param {HTMLElement} row - the live row
     * @param {HTMLElement} newRow - the parsed, inert server row
     * @returns {void}
     */
    const patchRow = (row, newRow) => {
      [...row.attributes].forEach((attr) => {
        if (!newRow.hasAttribute(attr.name)) row.removeAttribute(attr.name);
      });
      [...newRow.attributes].forEach((attr) => row.setAttribute(attr.name, attr.value));
      row.replaceChildren(...newRow.childNodes);
    };

    /**
     * Reconcile the live items list against the freshly server-rendered one,
     * matched by line key (falling back to variant id for a line whose key
     * regenerated). A row backed by a live op is skipped UNLESS this refresh
     * is that op's own settling batch (§3.5 port) — foreign in-flight work
     * is never touched; reassertOpVisuals() re-asserts every live op's
     * state after every reconcile.
     * @param {HTMLElement} currentList
     * @param {HTMLElement} newList
     * @param {number|null} settlingBatchId - the batch this refresh is settling, if any
     * @returns {void}
     */
    const reconcileItems = (currentList, newList, settlingBatchId = null) => {
      const newRows = [...newList.children].filter((el) => el.dataset.js === 'cart-item');
      const newKeys = new Set(newRows.map((row) => row.dataset.key));
      const liveRows = [...currentList.children].filter((el) => el.dataset.js === 'cart-item');
      const claimed = new Set();

      const isForeignWork = (row) => {
        const op = findOp(row.dataset.key, row.dataset.id);
        return !!op && !(op.state === 'settling' && op.batchId === settlingBatchId);
      };

      const matchLive = (newRow) => {
        const byKey = liveRows.find((row) => !claimed.has(row) && row.dataset.key === newRow.dataset.key);
        if (byKey) return byKey;
        return (
          liveRows.find(
            (row) =>
              !claimed.has(row) &&
              !newKeys.has(row.dataset.key) &&
              !row.dataset.removing &&
              row.dataset.id === newRow.dataset.id
          ) || null
        );
      };

      const pairs = newRows.map((newRow) => {
        const live = matchLive(newRow);
        if (live) claimed.add(live);
        return { newRow, live };
      });

      // Live rows the server no longer has collapse out — unless the row is
      // foreign in-flight work, in which case it's left alone entirely.
      liveRows.forEach((row) => {
        if (claimed.has(row) || isForeignWork(row)) return;
        if (row.dataset.collapsed) row.remove(); // already collapsed — no second collapse (D9)
        else removeRowWhenCollapsed(row);
      });

      let cursor = currentList.firstElementChild;
      pairs.forEach(({ newRow, live }) => {
        while (cursor && !claimed.has(cursor)) cursor = cursor.nextElementSibling;

        if (!live) {
          currentList.insertBefore(newRow, cursor);
          return;
        }

        if (live === cursor) cursor = cursor.nextElementSibling;
        else currentList.insertBefore(live, cursor);

        if (isForeignWork(live)) return; // skip: foreign in-flight work (§3.5)

        patchRow(live, newRow);
      });
    };

    // ── Focus management (§5, T5 port) ──────────────────────────
    // reconcileItems()/patchRow() can destroy the DOM node a stepper, remove
    // button, or size select currently holds focus on. captureRowFocus()
    // records which row + control held focus immediately before a body
    // patch; restoreRowFocus() re-focuses the equivalent control afterwards
    // so keyboard/screen-reader focus never silently falls back to <body>.

    /**
     * Identify which of a row's known focusable controls an element is, as
     * a selector scoped to `[data-js="cart-item"]` — stable across
     * patchRow() replacing the row's children with a freshly-parsed server
     * copy.
     * @param {HTMLElement} el
     * @returns {string|null} null if el isn't one of the row's controls
     */
    const focusableRowControlSelector = (el) => {
      if (el.matches('[data-cart-quantity]')) {
        return `[data-cart-quantity][data-function="${el.dataset.function}"]`;
      }
      if (el.matches('[data-cart-quantity-input]')) return '[data-cart-quantity-input]';
      if (el.matches('[data-cart-remove]')) return '[data-cart-remove]';
      if (el.matches('[data-cart-size-select]')) return '[data-cart-size-select]';
      if (el.matches('.cart-page__item-title')) return '.cart-page__item-title';
      return null;
    };

    /**
     * @typedef {object} RowFocusSnapshot
     * @property {string} lineKey
     * @property {string} variantId
     * @property {string} selector - Selector for the focused control within the row.
     * @property {number} rowIndex
     * @property {string|null} nextKey
     * @property {string|null} prevKey
     */

    /**
     * Record which row + control holds focus before a body patch, so it can
     * be restored after. Ignores focus outside the items list
     * entirely — a refresh must never steal focus that wasn't already there.
     * Doubled braces are Liquid syntax even inside JSDoc, so the shape lives
     * in the RowFocusSnapshot typedef rather than an inline object type.
     * @returns {RowFocusSnapshot|null}
     */
    const captureRowFocus = () => {
      const active = document.activeElement;
      const itemsList = getItemsList();
      if (!active || !itemsList || !itemsList.contains(active)) return null;
      const row = active.closest('[data-js="cart-item"]');
      if (!row) return null;
      const selector = focusableRowControlSelector(active);
      if (!selector) return null;
      const rows = [...itemsList.children].filter((el) => el.dataset.js === 'cart-item');
      const rowIndex = rows.indexOf(row);
      return {
        lineKey: row.dataset.key,
        variantId: row.dataset.id,
        selector,
        rowIndex,
        nextKey: rows[rowIndex + 1]?.dataset.key || null,
        prevKey: rows[rowIndex - 1]?.dataset.key || null,
      };
    };

    /**
     * Restore focus captured by captureRowFocus() once a body patch has
     * landed (§5, T5). Every rung is verified — `.focus()` on a
     * display:none target silently no-ops, so each candidate is checked and
     * skipped rather than trusted blind.
     * @param {ReturnType<typeof captureRowFocus>} captured
     * @returns {void}
     */
    const restoreRowFocus = (captured) => {
      if (!captured) return;
      const itemsList = getItemsList();
      if (!itemsList) return;

      const findRow = (key, variantId) =>
        (key && itemsList.querySelector(`[data-js="cart-item"][data-key="${CSS.escape(key)}"]`)) ||
        (variantId && itemsList.querySelector(`[data-js="cart-item"][data-id="${CSS.escape(variantId)}"]`)) ||
        null;

      const tryFocus = (el) => {
        if (!el) return false;
        el.focus({ preventScroll: true });
        return document.activeElement === el;
      };

      const isLive = (row) => row && !row.dataset.removing && !row.dataset.collapsed;

      const sameRow = findRow(captured.lineKey, captured.variantId);
      if (isLive(sameRow)) {
        const control = sameRow.querySelector(captured.selector);
        if (tryFocus(control) || tryFocus(sameRow)) return;
      }

      const rows = [...itemsList.children].filter((el) => el.dataset.js === 'cart-item');
      const fallbackRows = [
        findRow(captured.nextKey, null),
        findRow(captured.prevKey, null),
        rows[captured.rowIndex],
        rows[captured.rowIndex - 1],
      ].filter(isLive);
      for (const fallbackRow of fallbackRows) {
        const control = fallbackRow.querySelector('[data-cart-remove]');
        if (tryFocus(control) || tryFocus(fallbackRow)) return;
      }

      const emptyState = getEmptyState();
      const emptyLink = emptyState && !emptyState.hidden ? emptyState.querySelector('a, button') : null;
      if (tryFocus(emptyLink)) return;

      const title = root.querySelector('.cart-page__title');
      tryFocus(title);
    };

    /**
     * Reconcile the whole page against a freshly server-rendered root:
     * header count, item rows (keyed), order summary, checkout buttons
     * and the empty state. Captures/restores focus around the item patch
     * (§5, T5 port) and reasserts any still-live op's visuals afterwards
     * (§3.5 port).
     * @param {HTMLElement} newRoot - the parsed, inert `[data-js="cart-page"]`.
     * @param {number|null} settlingBatchId - the batch this refresh is settling, if any
     * @returns {void}
     */
    const reconcileCartPage = (newRoot, settlingBatchId = null) => {
      const newCount = newRoot.querySelector('[data-cart-header-count]');
      const currentCount = root.querySelector('[data-cart-header-count]');
      if (newCount && currentCount) {
        currentCount.replaceWith(newCount);
      } else if (newCount && !currentCount) {
        root.querySelector('.cart-page__header')?.appendChild(newCount);
      } else if (!newCount && currentCount) {
        currentCount.remove();
      }

      const newItemsList = newRoot.querySelector('[data-cart-items]');
      const currentItemsList = getItemsList();
      // Snapshot focus BEFORE any row is patched/removed below (§5, T5).
      const focusCapture = captureRowFocus();
      if (newItemsList && currentItemsList) reconcileItems(currentItemsList, newItemsList, settlingBatchId);
      restoreRowFocus(focusCapture);

      const newLayout = newRoot.querySelector('[data-cart-layout]');
      const layout = getLayout();
      const newEmpty = newRoot.querySelector('[data-cart-empty-state]');
      const empty = getEmptyState();
      if (newLayout && layout && newEmpty && empty) {
        const serverHasItems = !newLayout.hidden;
        const wasOptimisticEmpty = layout.hidden && !empty.hidden;
        if (serverHasItems && wasOptimisticEmpty) {
          // A failed last-line removal the server bounced back — reverse the
          // optimistic empty-state transition instead of instantly snapping.
          reverseTransitionToEmpty();
        } else {
          // A confirming refresh (or an external mutation with no local
          // optimistic transition to reverse) — snap straight to server
          // truth. Any still-playing entrance animation is left alone: if
          // this flips `hidden`, the browser fires `animationcancel` on the
          // now-display:none element, which transitionToEmpty()'s own
          // cleanup already handles (§4 interruptibility rule) — no need to
          // race it by clearing the attribute here too.
          layout.hidden = newLayout.hidden;
          empty.hidden = newEmpty.hidden;
        }
      }

      const newBreakdown = newRoot.querySelector('.cart-page__breakdown');
      const currentBreakdown = root.querySelector('.cart-page__breakdown');
      if (newBreakdown && currentBreakdown) currentBreakdown.replaceChildren(...newBreakdown.childNodes);

      const newCheckoutButtons = newRoot.querySelector('.cart-page__checkout-buttons');
      const currentCheckoutButtons = root.querySelector('.cart-page__checkout-buttons');
      if (newCheckoutButtons && currentCheckoutButtons) {
        currentCheckoutButtons.replaceChildren(...newCheckoutButtons.childNodes);
      }

      // Any optimistic change still pending stays visually ahead of this
      // snapshot, whoever triggered the refresh.
      reassertOpVisuals();
    };

    /**
     * Refresh the page from the Section Rendering API (or a prefetched
     * sections payload) and reconcile the live DOM. Token-guarded against
     * stale, out-of-order responses.
     * @param {Object|null} prefetchedSections - section HTML keyed by rendering id, when already known.
     * @param {number} token - the caller's `refreshRequestToken` snapshot.
     * @param {number|null} [settlingBatchId] - the batch this refresh is settling, if any.
     * @returns {Promise<Object|null>} the resolved sections payload, for callers that also need to sync the minicart.
     */
    const refreshCartPage = async (prefetchedSections, token, settlingBatchId = null) => {
      try {
        let sections = prefetchedSections;
        if (!sections?.[PAGE_SECTION_ID]) {
          // Render in this page's URL context — the template-scoped cart
          // section does not resolve at the storefront root.
          const res = await fetch(`${window.location.pathname}?sections=${encodeURIComponent(SECTIONS_TO_FETCH)}`, {
            signal: AbortSignal.timeout(FETCH_TIMEOUT_MS),
          });
          if (!res.ok) return null;
          sections = await res.json();
        }

        if (token !== refreshRequestToken) return sections;

        const pageHtml = sections?.[PAGE_SECTION_ID];
        if (!pageHtml) return sections;

        const doc = new DOMParser().parseFromString(pageHtml, 'text/html');
        const newRoot = doc.querySelector('[data-js="cart-page"]');
        if (!newRoot) return sections;

        reconcileCartPage(newRoot, settlingBatchId);
        return sections;
      } catch {
        return null;
      }
    };

    // ── Quantity batch pipeline ────────────────────────────────

    /**
     * Announce the outcome of a flush (removal vs quantity update), once.
     * @param {Map<string, number>} snapshot
     * @returns {void}
     */
    const announceFlush = (snapshot) => {
      const removedText = root.dataset.textItemRemoved;
      const updatedTpl = root.dataset.textQuantityUpdated || '';
      const entries = [...snapshot.entries()];
      const allRemoval = entries.every(([, q]) => q <= 0);
      if (allRemoval) {
        announce(removedText);
        return;
      }
      if (entries.length === 1) {
        announce(updatedTpl.replace(/\x7b\x7b\s*quantity\s*\x7d\x7d/, entries[0][1]));
        return;
      }
      announce(updatedTpl.replace(/\x7b\x7b\s*quantity\s*\x7d\x7d/, '').trim());
    };

    /**
     * After a flush, compare requested quantities against the returned cart
     * and surface a per-line notice for any silently-clamped line.
     * @param {Map<string, number>} snapshot
     * @param {Object} cartData
     * @returns {void}
     */
    const detectClamp = (snapshot, cartData) => {
      if (!cartData || !Array.isArray(cartData.items)) return;
      const byKey = new Map(cartData.items.map((i) => [i.key, i.quantity]));
      const message = root.dataset.textQuantityAdjusted;
      snapshot.forEach((requestedQty, lineKey) => {
        if (requestedQty <= 0) return;
        const actual = byKey.get(lineKey);
        if (typeof actual === 'number' && actual < requestedQty) showItemError(lineKey, message);
      });
    };

    /**
     * Fade in the rows whose op just settled successfully. Skips any key
     * that still holds a live op (generation moved on mid-flight) — no fade
     * restarts mid-interaction.
     * @param {string[]} settledKeys
     * @returns {void}
     */
    const stampFreshRows = (settledKeys) => {
      if (prefersReducedMotion) return;
      const itemsList = getItemsList();
      if (!itemsList) return;
      settledKeys.forEach((lineKey) => {
        if (lineOps.has(lineKey)) return;
        const el = itemsList.querySelector(`[data-js="cart-item"][data-key="${CSS.escape(lineKey)}"]`);
        if (!el) return;
        el.setAttribute('data-fresh', 'true');
        let fallback;
        const cleanup = () => {
          clearTimeout(fallback);
          el.removeAttribute('data-fresh');
          el.removeEventListener('animationend', onFreshEnd);
          el.removeEventListener('animationcancel', cleanup);
        };
        function onFreshEnd(e) {
          if (e.animationName !== 'cart-page-item-fresh') return;
          cleanup();
        }
        el.addEventListener('animationend', onFreshEnd);
        el.addEventListener('animationcancel', cleanup);
        fallback = setTimeout(cleanup, 300); // above the 240ms fresh-fade duration
      });
    };

    /**
     * POST one batched cart/update.js for a batch's snapshot, refresh the
     * DOM, detect silent clamps, then settle every op the batch carried
     * (§3.2 port): unchanged-generation ops are deleted (success) or rolled
     * back and deleted (failure); ops whose generation moved on mid-flight
     * are left pending with a fresh baseQty from the server response.
     * @param {number} batchId
     * @param {Map<string, number>} snapshot
     * @returns {Promise<void>}
     */
    const runQuantityFlush = async (batchId, snapshot) => {
      const updates = Object.fromEntries(snapshot);
      const data = await cartFetch('cart/update.js', { updates });
      const batchOps = () => [...lineOps.values()].filter((op) => op.batchId === batchId);

      if (!data || data.error) {
        batchOps().forEach((op) => {
          if (op.generation !== op.snapshotGeneration) return; // superseded — leave pending
          revertOptimisticUpdate(op);
          lineOps.delete(op.key);
        });
        // Server is the source of truth — refresh from it and surface the
        // error AFTER the refresh completes so nothing wipes it (D8).
        const token = ++refreshRequestToken;
        await refreshCartPage(null, token);
        showBannerError(extractErrorMessage(data));
        syncBusyUI();
        return;
      }

      batchOps().forEach((op) => {
        if (op.generation === op.snapshotGeneration) op.state = 'settling';
      });

      const token = ++refreshRequestToken;
      await refreshCartPage(data.sections, token, batchId);

      detectClamp(snapshot, data);

      const byKey = new Map((data.items || []).map((item) => [item.key, item.quantity]));
      const settledKeys = [];
      batchOps().forEach((op) => {
        if (op.generation === op.snapshotGeneration) {
          lineOps.delete(op.key);
          if (op.kind === 'quantity') settledKeys.push(op.key);
        } else {
          const freshQty = byKey.get(op.key);
          if (typeof freshQty === 'number') op.baseQty = freshQty;
          op.state = 'pending';
        }
      });

      stampFreshRows(settledKeys);
      announceFlush(snapshot);
      clearStaleBanner();
      syncBusyUI();
      syncMinicart(data.sections);
    };

    /**
     * Snapshot every pending op into a new batch and queue the flush. Ops
     * are stamped with the batch id + their current generation but never
     * deleted here (§3.1) — only their own batch's settle/failure deletes
     * them. Safe to call early (e.g. from the checkout guard).
     * @returns {void}
     */
    function flushQuantities() {
      if (quantityFlushTimer) {
        clearTimeout(quantityFlushTimer);
        quantityFlushTimer = null;
      }
      const pending = [...lineOps.values()].filter((op) => op.state === 'pending');
      if (pending.length === 0) return;

      const batchId = ++batchIdCounter;
      const snapshot = new Map();
      pending.forEach((op) => {
        op.state = 'inflight';
        op.batchId = batchId;
        op.snapshotGeneration = op.generation;
        snapshot.set(op.key, op.targetQty);
      });

      queueCartMutation(() => runQuantityFlush(batchId, snapshot));
    }

    /**
     * Queue a quantity change for the shared batch (qty ≤ 0 removes). A new
     * intent on a line with a live op mutates that op in place instead of
     * clearing it — baseQty (the rollback value) is left untouched (§3.1).
     * @param {HTMLElement} itemEl
     * @param {string} lineKey
     * @param {number} newQty
     * @returns {void}
     */
    const queueQuantity = (itemEl, lineKey, newQty) => {
      const qty = Math.max(0, newQty);
      const kind = qty <= 0 ? 'remove' : 'quantity';

      // Idempotent remove (D4): a removal already queued/in-flight for this
      // line is a no-op.
      if (kind === 'remove' && lineOps.get(lineKey)?.kind === 'remove') return;

      let op = lineOps.get(lineKey);
      if (!op) {
        const qtyInput = itemEl.querySelector('[data-cart-quantity-input]');
        const currentQty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;
        op = {
          key: lineKey,
          kind,
          targetQty: qty,
          targetVariantId: null,
          baseQty: currentQty,
          baseVariantId: null,
          state: 'pending',
          generation: 0,
          snapshotGeneration: -1,
          batchId: null,
          rowEl: itemEl,
        };
        lineOps.set(lineKey, op);
      } else {
        op.kind = kind;
        op.targetQty = qty;
        op.rowEl = itemEl;
      }
      op.state = 'pending';
      op.generation += 1;

      if (qty <= 0) {
        const rows = [...(getItemsList()?.children || [])].filter((el) => el.dataset.js === 'cart-item');
        // Registry-based, not data-removing-based (D4): transition to empty
        // only once every remaining row carries its own remove op.
        const anyRemaining = rows.some((row) => lineOps.get(row.dataset.key)?.kind !== 'remove');
        // Relocate focus BEFORE either path hides the row (or, last line,
        // the whole items list) — see relocateFocusForRemoval.
        relocateFocusForRemoval(itemEl, !anyRemaining);
        if (!anyRemaining) transitionToEmpty();
        else animateItemRemoval(itemEl);
      } else {
        applyOptimisticUpdate(itemEl, qty);
      }

      syncBusyUI();

      if (quantityFlushTimer) clearTimeout(quantityFlushTimer);
      quantityFlushTimer = setTimeout(flushQuantities, DEBOUNCE_MS);
    };

    // ── Quantity / remove handlers ─────────────────────────────

    /**
     * @param {HTMLElement} button
     * @returns {void}
     */
    const handleQuantityButtonClick = (button) => {
      const currentQty = parseInt(button.dataset.currentQty, 10);
      const itemEl = button.closest('[data-js="cart-item"]');
      const lineKey = itemEl?.dataset.key;
      if (!lineKey) return;
      const isAdd = button.dataset.function === 'add';
      let newQty = isAdd ? currentQty + 1 : currentQty - 1;
      if (isAdd) {
        const max = parseInt(itemEl.dataset.max, 10);
        if (!isNaN(max) && newQty > max) {
          showItemError(lineKey, root.dataset.textQuantityAdjusted);
          return;
        }
        newQty = Math.min(99, newQty);
      }
      queueQuantity(itemEl, lineKey, newQty);
    };

    /**
     * @param {HTMLElement} input
     * @returns {void}
     */
    const handleQuantityInputChange = (input) => {
      const itemEl = input.closest('[data-js="cart-item"]');
      const lineKey = itemEl?.dataset.key;
      if (!lineKey) return;
      const parsed = parseInt(input.value, 10);
      if (isNaN(parsed)) {
        const prev = itemEl.querySelector('[data-cart-quantity]')?.dataset.currentQty ?? '1';
        input.value = prev;
        return;
      }
      const max = parseInt(itemEl.dataset.max, 10);
      if (!isNaN(max) && parsed > max) {
        const prev = itemEl.querySelector('[data-cart-quantity]')?.dataset.currentQty ?? '1';
        input.value = prev;
        showItemError(lineKey, root.dataset.textQuantityAdjusted);
        return;
      }
      const clamped = Math.min(99, Math.max(0, parsed));
      input.value = String(clamped);
      queueQuantity(itemEl, lineKey, clamped);
    };

    /**
     * @param {HTMLElement} button
     * @returns {void}
     */
    const handleRemoveClick = (button) => {
      const itemEl = button.closest('[data-js="cart-item"]');
      const lineKey = itemEl?.dataset.key;
      if (!lineKey) return;
      queueQuantity(itemEl, lineKey, 0);
    };

    /**
     * Size change: swap the line to the new variant, merging into an
     * existing line of the target variant if one already exists.
     * @param {HTMLSelectElement} select
     * @returns {void}
     */
    const handleSizeSelectChange = (select) => {
      const newVariantId = select.value;
      const item = select.closest('[data-js="cart-item"]');
      const lineKey = item?.dataset.key;
      if (!newVariantId || !item || !lineKey) return;
      if (newVariantId === select.dataset.currentVariantId) return; // no-op guard

      const baseVariantId = select.getAttribute('data-current-variant-id') || select.value;

      // Register a size op (§3.1 port) so a concurrent refresh (e.g. a
      // queued quantity flush on another line, or an external cart:added)
      // recognises this row as foreign in-flight work and leaves it alone
      // (D2). Stated exception to "mutate in place" — same as the minicart's
      // own size-select handler: this overwrites any live pending/inflight
      // quantity or remove op already registered for lineKey rather than
      // merging into it.
      lineOps.set(lineKey, {
        key: lineKey,
        kind: 'size',
        targetQty: null,
        targetVariantId: newVariantId,
        baseQty: null,
        baseVariantId,
        state: 'inflight',
        generation: 0,
        snapshotGeneration: 0,
        batchId: null,
        rowEl: item,
      });
      item.dataset.pending = 'true';
      syncBusyUI();

      const qtyInput = item.querySelector('[data-cart-quantity-input]');
      const currentQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

      let targetQty = currentQty;
      const existing = getItemsList()?.querySelector(`[data-js="cart-item"][data-id="${CSS.escape(newVariantId)}"]`);
      if (existing && existing !== item) {
        const existingQtyInput = existing.querySelector('[data-cart-quantity-input]');
        if (existingQtyInput) targetQty += parseInt(existingQtyInput.value, 10) || 0;
      }

      const updates = {};
      updates[lineKey] = 0;
      updates[newVariantId] = targetQty;

      queueCartMutation(async () => {
        const token = ++refreshRequestToken;
        const data = await cartFetch('cart/update.js', { updates });
        const op = lineOps.get(lineKey);
        lineOps.delete(lineKey);
        if (!data || data.error) {
          if (op) revertOptimisticUpdate(op);
          else delete item.dataset.pending;
          await refreshCartPage(null, token);
          showBannerError(extractErrorMessage(data));
          syncBusyUI();
          return;
        }
        await refreshCartPage(data.sections, token);
        clearStaleBanner();
        syncBusyUI();
        syncMinicart(data.sections);
      });
    };

    // ── Discounts ──────────────────────────────────────────────

    const getDiscountElements = () => ({
      input: root.querySelector('[data-cart-discount-input]'),
      applyBtn: root.querySelector('[data-cart-discount-apply]'),
      error: root.querySelector('[data-cart-discount-error]'),
      note: root.querySelector('[data-cart-discount-note]'),
      panel: root.querySelector('[data-cart-discount-panel]'),
    });

    /**
     * Drive the discount panel's open / error state via data-attributes.
     * @param {Object} [state] - { open?: boolean, isError?: boolean, message?: string|null }
     * @returns {void}
     */
    const setDiscountUiState = ({ open = false, isError = false, message = null } = {}) => {
      const { input, error, note, panel } = getDiscountElements();
      setBool(input, 'data-error', isError);
      setBool(error, 'data-hidden', !isError);
      setBool(note, 'data-hidden', isError);
      setBool(panel, 'data-open', open || isError);
      if (isError && message && error) error.textContent = message;
    };

    /**
     * @param {boolean} loading
     * @returns {void}
     */
    const setDiscountLoading = (loading) => {
      const { input, applyBtn } = getDiscountElements();
      const target = input || root.querySelector('[data-cart-discount-remove]');
      if (!target) return;
      if (loading) {
        setBool(target, 'data-loading', true);
        if (input) input.disabled = true;
        if (applyBtn) {
          setBool(applyBtn, 'data-loading', true);
          applyBtn.disabled = true;
        }
      } else {
        target.removeAttribute('data-loading');
        if (input) input.disabled = false;
        if (applyBtn) {
          applyBtn.removeAttribute('data-loading');
          applyBtn.disabled = !input?.value.trim();
        }
      }
    };

    // POST the discount mutation. Not queued itself — updateDiscountAndRefresh
    // queues its whole fetch+refresh flow as a single unit (see its own doc).
    const applyDiscountCode = (discount) => cartFetch('cart/update.js', { discount });

    /**
     * Apply or remove (empty string) a discount code, then refresh + sync.
     * Claims `refreshRequestToken` INSIDE the queued mutation, after its own
     * fetch resolves (mirrors runQuantityFlush) — not at click time, so a
     * quantity flush queued ahead of this can't make this refresh's own
     * token look stale before its fetch has even started (D6 port).
     * @param {string} discount
     * @returns {Promise<void>}
     */
    const updateDiscountAndRefresh = (discount) => {
      setDiscountLoading(true);

      if (discountErrorTimer) {
        clearTimeout(discountErrorTimer);
        discountErrorTimer = null;
      }

      const showError = (msg) => {
        setDiscountUiState({ open: true, isError: true, message: msg });
        setDiscountLoading(false);
        discountErrorTimer = setTimeout(() => {
          setDiscountUiState({ open: false, isError: false });
          const { input, applyBtn } = getDiscountElements();
          if (input) input.value = '';
          if (applyBtn) applyBtn.disabled = true;
          discountErrorTimer = null;
        }, 5000);
      };

      return queueCartMutation(async () => {
        const token = ++refreshRequestToken;

        if (discount === '') {
          const data = await applyDiscountCode('');
          if (data && !data.error) {
            await refreshCartPage(data.sections, token);
            setDiscountLoading(false);
            clearStaleBanner();
            syncMinicart(data.sections);
          } else {
            showError(root.dataset.textDiscountRemoveError);
          }
          return;
        }

        const cartData = await applyDiscountCode(discount);
        const invalidMsg = root.dataset.textDiscountInvalid;

        if (!cartData || cartData.error) {
          showError(invalidMsg);
          return;
        }

        const wasApplied = cartData.discount_codes?.some(
          (d) => d.code.toLowerCase() === discount.toLowerCase() && d.applicable
        );

        if (wasApplied) {
          await refreshCartPage(cartData.sections, token);
          setDiscountLoading(false);
          clearStaleBanner();
          syncMinicart(cartData.sections);
        } else {
          showError(invalidMsg);
        }
      });
    };

    const handleDiscountSubmit = () => {
      const { input, applyBtn } = getDiscountElements();
      if (!input || !applyBtn || applyBtn.disabled) return;
      const code = input.value.trim();
      if (!code) return;
      const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
      setDiscountUiState({ open: isTouchDevice, isError: false });
      if (!isTouchDevice) input.blur();
      updateDiscountAndRefresh(code);
    };

    // ── Sticky mobile checkout bar ─────────────────────────────

    /** Show the sticky checkout bar on mobile while the summary is off-screen. */
    const initialiseStickyBar = () => {
      const bar = root.querySelector('[data-cart-sticky-bar]');
      const summary = getSummary();
      if (!bar || !summary || !('IntersectionObserver' in window)) return;

      const mobileQuery = window.matchMedia('(min-width: 768px)');
      let observer = null;

      const disconnectObserver = () => {
        observer?.disconnect();
        observer = null;
        bar.hidden = true;
      };

      const connectObserver = () => {
        if (observer) return;
        observer = new IntersectionObserver(
          (entries) => {
            bar.hidden = entries[entries.length - 1].isIntersecting;
          },
          { threshold: 0 }
        );
        observer.observe(summary);
      };

      const syncObserver = () => {
        if (mobileQuery.matches) disconnectObserver();
        else connectObserver();
      };

      mobileQuery.addEventListener('change', syncObserver);
      syncObserver();
    };

    // ── Event delegation (root) ────────────────────────────────

    root.addEventListener('click', (event) => {
      const quantityBtn = event.target.closest('[data-cart-quantity]');
      if (quantityBtn) {
        handleQuantityButtonClick(quantityBtn);
        return;
      }

      const removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        handleRemoveClick(removeBtn);
        return;
      }

      const discountRemove = event.target.closest('[data-cart-discount-remove]');
      if (discountRemove) {
        updateDiscountAndRefresh('');
        return;
      }

      const discountApply = event.target.closest('[data-cart-discount-apply]');
      if (discountApply) {
        event.preventDefault();
        handleDiscountSubmit();
        return;
      }

      const bannerDismiss = event.target.closest('[data-cart-banner-dismiss]');
      if (bannerDismiss) {
        if (bannerDismissTimer) clearTimeout(bannerDismissTimer);
        hideBanner();
      }
    });

    root.addEventListener('change', (event) => {
      const quantityInput = event.target.closest('[data-cart-quantity-input]');
      if (quantityInput) {
        handleQuantityInputChange(quantityInput);
        return;
      }
      const sizeSelect = event.target.closest('[data-cart-size-select]');
      if (sizeSelect) handleSizeSelectChange(sizeSelect);
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      if (!event.target.closest('[data-cart-discount-input]')) return;
      event.preventDefault();
      handleDiscountSubmit();
    });

    root.addEventListener('input', (event) => {
      const input = event.target.closest('[data-cart-discount-input]');
      if (!input) return;
      const { applyBtn } = getDiscountElements();
      const hasValue = input.value.trim().length > 0;
      if (applyBtn) applyBtn.disabled = !hasValue;
      if (discountErrorTimer || input.hasAttribute('data-error')) {
        if (discountErrorTimer) {
          clearTimeout(discountErrorTimer);
          discountErrorTimer = null;
        }
        setDiscountUiState({ open: hasValue, isError: false });
      }
    });

    root.addEventListener('focusin', (event) => {
      const input = event.target.closest('[data-cart-discount-input]');
      if (!input) return;
      if (!input.hasAttribute('data-error')) setDiscountUiState({ open: true, isError: false });
    });

    root.addEventListener('focusout', (event) => {
      const input = event.target.closest('[data-cart-discount-input]');
      if (!input) return;
      setTimeout(() => {
        if (input === document.activeElement) return;
        if (input.hasAttribute('data-loading') || input.hasAttribute('data-error')) return;
        setDiscountUiState({ open: input.value.trim().length > 0, isError: false });
      }, 150);
    });

    // ── Checkout integrity (T3 port) — always clickable (§1 decision 4) ──
    // Checkout must never post a stale cart, but syncing must never make a
    // checkout button unclickable. A busy click flushes pending work, shows
    // a visible awaiting state, then either proceeds or backs off leaving
    // the failure banner up. `requestSubmit(button)` (not `.submit()`)
    // preserves the button's `name="checkout"` submitter param, so a busy
    // click redirects to checkout instead of posting a bare cart update
    // (D10). The sticky bar's button submits this same form
    // (`form="cart-page-checkout-form"`) and `submit` bubbles, so one
    // delegated listener covers both triggers; `event.submitter` identifies
    // which one was actually clicked. requestSubmit() re-dispatches 'submit'
    // through this same listener; once genuinely idle it falls straight
    // through the guard above and the browser performs the real submission —
    // a deliberate pass-through, not runaway recursion. The inline checkout
    // button (unlike the sticky one) is replaced by every reconcile's
    // `.cart-page__checkout-buttons` patch, so it's re-resolved live after
    // the await rather than trusted from closure.
    root.addEventListener('submit', async (event) => {
      if (event.target?.id !== 'cart-page-checkout-form') return;
      if (!isCartBusy()) return; // idle cart: normal, unmodified single POST
      event.preventDefault();

      const form = event.target;
      const clickedButton = event.submitter;
      if (clickedButton?.dataset.awaiting === 'true') return; // already awaiting a prior click
      if (clickedButton) {
        clickedButton.dataset.awaiting = 'true';
        clickedButton.setAttribute('aria-busy', 'true');
      }
      const wasSticky = clickedButton?.hasAttribute('data-cart-sticky-checkout');

      flushQuantities();
      // runQuantityFlush never rejects — a failure resolves into a banner
      // instead (§3.2) — so await the shared chain, then read whether a
      // failure banner just surfaced from it.
      await mutationChain.catch(() => {});

      const liveForm = document.getElementById('cart-page-checkout-form') || form;
      const liveButton = wasSticky
        ? root.querySelector('[data-cart-sticky-checkout]')
        : liveForm.querySelector('[data-cart-checkout]');
      const banner = root.querySelector('[data-cart-banner]');
      // A banner mid-dismiss (data-dismissing, ~200ms banner-out) is a stale
      // failure being cleared by an earlier flush's success, not this
      // flush's own failure — treat it as not-failed, else a checkout click
      // that lands during that animation wrongly backs off.
      const flushFailed = banner ? banner.hidden === false && !banner.hasAttribute('data-dismissing') : false;

      if (liveButton) {
        delete liveButton.dataset.awaiting;
        liveButton.removeAttribute('aria-busy');
      }

      if (flushFailed) return; // leave the banner up; nothing to submit yet
      // A last-item removal that just settled can leave the live button
      // server-rendered `disabled` (cart == empty) — requestSubmit() throws
      // on a disabled submitter, so bail rather than let that surface as an
      // unhandled rejection (defensive coding, §12).
      if (liveButton?.disabled) return;

      liveForm.requestSubmit(liveButton || undefined);
    });

    // ── Minicart sync (bidirectional, §11) ──────────────────────

    /**
     * Refresh this page from another surface's cart mutation, routed
     * through the mutation queue so the honest-loading dim (§3.3) covers it
     * and `isCartBusy()` correctly reflects the outstanding work.
     * @param {Object|null} prefetched - section HTML keyed by rendering id.
     * @returns {Promise<void>}
     */
    const refreshFromExternalMutation = (prefetched) =>
      queueCartMutation(async () => {
        const token = ++refreshRequestToken;
        await refreshCartPage(prefetched, token);
      });

    // Producers elsewhere (quick-add, wishlist) announce adds via cart:added.
    // Producer `event.detail.sections` snapshots are deliberately IGNORED
    // (D11 — matches sections/minicart.liquid's own cart:added handler):
    // they're rendered at the producer's add time, so when an add races this
    // page's own mutation, responses can arrive out of order and a snapshot
    // can predate a removal, resurrecting a deleted row. Flush any pending
    // work first so it lands before this refresh, then always re-fetch fresh
    // section HTML instead.
    document.addEventListener('cart:added', (event) => {
      if (event?.detail?.source === 'cart-page') return; // our own echo
      if (isCartBusy()) flushQuantities();
      refreshFromExternalMutation(null);
    });

    // The minicart dispatches cart:updated after every refresh; detail.cartData
    // is non-null ONLY for its own mutations (incoming cart:added refreshes
    // pass null), so this reconciles the page live while the drawer is open
    // without echo loops. cartData.sections carries this section's HTML
    // (bundled by the minicart on /cart), so no extra roundtrip — this is a
    // kept compatibility contract (§2), unlike the cart:added producer
    // snapshots above.
    document.addEventListener('cart:updated', (event) => {
      const cartData = event?.detail?.cartData;
      if (!cartData) {
        syncBusyUI();
        return;
      }
      const prefetched = cartData.sections?.[PAGE_SECTION_ID] ? cartData.sections : null;
      refreshFromExternalMutation(prefetched);
    });

    // Anticipatory loading state from the moment the shopper interacts with
    // the open minicart — bridges the gap before the cart:added/cart:updated
    // refresh above lands. Deliberately a direct attribute write, NOT folded
    // into isCartBusy()/syncBusyUI(): this page's own checkout guard must
    // only ever await ITS OWN mutationChain (§3.3 scope), never a signal it
    // can't actually wait on — feeding this into isCartBusy() would make a
    // busy checkout click preventDefault() and requestSubmit() in a loop
    // with nothing to clear it. It's purely visual, and always gets
    // corrected by the next syncBusyUI() call — refreshFromExternalMutation()
    // above is queued, so its own completion re-derives the honest value.
    const MINICART_MUTATION_HOOKS =
      '[data-minicart-quantity], [data-minicart-remove], [data-minicart-size-select], [data-minicart-discount-apply], [data-minicart-discount-remove]';
    // Some hook interactions never actually mutate — e.g. a `+` click at max
    // stock, or an invalid discount code — so they never dispatch
    // cart:added/cart:updated and the direct write above would otherwise dim
    // forever. Fall back to re-deriving the honest value from the real
    // registry (isCartBusy(), via syncBusyUI()) once a normal round trip
    // would already have landed; if genuine work IS outstanding this simply
    // re-confirms `data-syncing`, so it never clobbers a real busy state.
    let mutationHookSettleTimer = null;
    ['click', 'change'].forEach((type) => {
      document.addEventListener(type, (event) => {
        if (!event.target.closest?.(MINICART_MUTATION_HOOKS)) return;
        if (!event.target.closest(`#${MINICART_SECTION_ID}`)) return;
        setBool(root, 'data-syncing', true);
        clearTimeout(mutationHookSettleTimer);
        mutationHookSettleTimer = setTimeout(syncBusyUI, FETCH_TIMEOUT_MS + 1000);
      });
    });

    // ── Initialise ─────────────────────────────────────────────

    initialiseStickyBar();

    // The recommendations rail hydrates itself (`<athos-carousel>`);
    // hide the whole region, heading included, if the profile comes back empty.
    const recommendationsRegion = root.querySelector('[data-js="cart-recommendations-section"]');
    recommendationsRegion?.addEventListener('carousel:empty', () => {
      recommendationsRegion.hidden = true;
    });
  }

  document.querySelectorAll('[data-js="cart-page"]:not([data-initialised="true"])').forEach(initialiseCartPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
  /**
   * Tab switcher for `collection-carousel`. WAI-ARIA tabs
   * pattern: click + ←/→/Home/End. Activation follows focus.
   *
   * Empty `<athos-carousel>` rails bubble
   * `carousel:empty`. If the primary rail empties and the panel has
   * a fallback Searchspring rail we reveal + hydrate it and swap the
   * tab title to the fallback title. If the fallback also empties (or
   * there is no fallback) we hide the tab + panel and activate the
   * next visible one — hiding the whole section if none remain.
   *
   * Searchspring rails dispatch `carousel:initialised` once
   * results are appended; we use that to hide the skeleton
   * placeholders sitting directly in front of that rail.
   *
   * Tab selection persists per-section in sessionStorage so the
   * user's choice survives page reloads. Inner slide position is
   * never persisted — every page load starts at slide 0.
   *
   * Idempotent — guards against double-init when the theme editor
   * re-renders the section.
   */
  (function () {
    const STORAGE_PREFIX = 'pm:fcc:';

    document.querySelectorAll('[data-js="collection-carousel"]').forEach((section) => {
      if (section.dataset.freshInit === 'true') return;
      section.dataset.freshInit = 'true';

      const sectionId = section.dataset.sectionId || '';
      const tabs = Array.from(section.querySelectorAll('[data-js="collection-carousel-tab"]'));
      const panels = Array.from(section.querySelectorAll('[data-js="collection-carousel-panel"]'));

      // ─── helpers ────────────────────────────────
      function tabFor(panel) {
        return tabs.find((t) => t.dataset.panel === panel.id) || null;
      }

      function initRailsIn(panel) {
        // Searchspring rails may need an explicit forceInit() when
        // their panel was previously hidden (clientWidth was 0).
        panel.querySelectorAll('athos-carousel').forEach((rail) => {
          if (rail.hasAttribute('hidden')) return;
          if (typeof rail.forceInit === 'function') rail.forceInit();
        });
        // Plain `<carousel-slider>` rails (collection-type blocks)
        // are only initialised when visible.
        panel.querySelectorAll('carousel-slider').forEach((rail) => {
          if (rail.hasAttribute('hidden') || rail.closest('[hidden]')) return;
          if (typeof rail.forceInit === 'function') rail.forceInit();
        });
      }

      function persistActive(panelId) {
        try {
          if (sectionId) sessionStorage.setItem(STORAGE_PREFIX + sectionId, panelId);
        } catch (_e) {
          /* private mode — ignore */
        }
      }

      function readPersisted() {
        try {
          return sectionId ? sessionStorage.getItem(STORAGE_PREFIX + sectionId) : null;
        } catch (_e) {
          return null;
        }
      }

      function dispatchTabChange(tab, source) {
        const panel = panels.find((p) => p.id === tab.dataset.panel);
        if (!panel) return;
        section.dispatchEvent(
          new CustomEvent('collection-carousel:tab-change', {
            bubbles: true,
            composed: true,
            detail: {
              panelId: panel.id,
              tabIndex: tabs.indexOf(tab),
              blockType: panel.dataset.blockType || '',
              profileId: panel.dataset.profileId || '',
              collectionHandle: panel.dataset.collectionHandle || '',
              source: source,
            },
          })
        );
      }

      // ─── activate ──────────────────────────────
      function activate(tab, opts) {
        if (!tab || tab.hasAttribute('hidden')) return;
        opts = opts || {};
        const focus = !!opts.focus;
        const source = opts.source || 'user';

        tabs.forEach((t) => {
          t.setAttribute('aria-selected', String(t === tab));
        });
        const panelId = tab.dataset.panel;
        panels.forEach((p) => {
          if (p.id === panelId) {
            p.removeAttribute('hidden');
            // Defer until layout so rails inside the panel can
            // measure non-zero box dimensions before init.
            requestAnimationFrame(() => initRailsIn(p));
          } else {
            p.setAttribute('hidden', '');
          }
        });
        if (focus) tab.focus({ preventScroll: true });
        persistActive(panelId);
        dispatchTabChange(tab, source);
      }

      // ─── tab events ────────────────────────────
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activate(tab, { focus: false, source: 'user' }));
        tab.addEventListener('keydown', (event) => {
          const visibleTabs = tabs.filter((t) => !t.hasAttribute('hidden'));
          const currentIndex = visibleTabs.indexOf(tab);
          let next;
          switch (event.key) {
            case 'ArrowRight':
              next = visibleTabs[(currentIndex + 1) % visibleTabs.length];
              break;
            case 'ArrowLeft':
              next = visibleTabs[(currentIndex - 1 + visibleTabs.length) % visibleTabs.length];
              break;
            case 'Home':
              next = visibleTabs[0];
              break;
            case 'End':
              next = visibleTabs[visibleTabs.length - 1];
              break;
            default:
              return;
          }
          event.preventDefault();
          activate(next, { focus: true, source: 'user' });
        });
      });

      // ─── boot: restore persisted tab, else first ──────────
      const persistedPanelId = readPersisted();
      const persistedTab = persistedPanelId
        ? tabs.find((t) => t.dataset.panel === persistedPanelId && !t.hasAttribute('hidden'))
        : null;
      if (persistedTab && persistedTab.getAttribute('aria-selected') !== 'true') {
        activate(persistedTab, { focus: false, source: 'restore' });
      } else {
        // Boot the initially visible panel after layout.
        requestAnimationFrame(() => {
          const visible = panels.find((p) => !p.hasAttribute('hidden'));
          if (visible) initRailsIn(visible);
          // Still dispatch a tab-change so analytics sees the
          // initial impression.
          const activeTab = tabs.find((t) => t.getAttribute('aria-selected') === 'true');
          if (activeTab) dispatchTabChange(activeTab, 'init');
        });
      }

      // ─── searchspring → fallback / empty handling ─────────
      function skeletonsFor(rail) {
        // Each rail is preceded by its own skeleton placeholders.
        const prev = rail.previousElementSibling;
        return prev && prev.matches('[data-js="collection-carousel-skeletons"]') ? prev : null;
      }

      section.addEventListener('carousel:initialised', (event) => {
        const panel = event.target.closest('[data-js="collection-carousel-panel"]');
        if (!panel) return;
        // Once a Searchspring rail successfully hydrates, fade the
        // skeleton placeholders that belong to it, then remove them.
        const skeletons = skeletonsFor(event.target);
        if (skeletons) {
          skeletons.dataset.resolved = 'true';
          setTimeout(() => skeletons.setAttribute('hidden', ''), 250);
        }

        // Searchspring rails swap in client-hydrated cards, so stagger
        // their below-image content in the first time a rail hydrates.
        // Plain collection rails render cards server-side and are left
        // alone. Guarded so re-activating a cached tab, or a rail
        // re-initialising, never replays the entrance.
        if (event.target.matches('athos-carousel') && event.target.dataset.cardsResolved !== 'true') {
          event.target.dataset.cardsResolved = 'true';
          const track = event.target.querySelector('[data-js="carousel-track"]');
          if (track) {
            track.setAttribute('data-cards-resolving', '');
            setTimeout(() => track.removeAttribute('data-cards-resolving'), 700);
          }
        }

        // A fallback rail only reaches this point once it has results.
        // Swap the tab title now — deferring it until here means an
        // empty fallback (which just hides the tab) never flashes a
        // title first.
        if (event.target.matches('[data-js="collection-carousel-fallback"]')) {
          const tab = tabFor(panel);
          const fallbackTitle = event.target.dataset.fallbackTabTitle;
          if (tab && fallbackTitle) {
            const label = tab.querySelector('[data-js="collection-carousel-tab-label"]');
            if (label) label.textContent = fallbackTitle;
          }
          // Mirror the fallback profile onto the panel for analytics.
          panel.dataset.profileId = event.target.dataset.athosId || '';
        }
      });

      section.addEventListener('carousel:empty', (event) => {
        const panel = event.target.closest('[data-js="collection-carousel-panel"]');
        if (!panel) return;

        // Hide the skeletons belonging to the rail that just emptied.
        const emptySkeletons = skeletonsFor(event.target);
        if (emptySkeletons) emptySkeletons.setAttribute('hidden', '');

        const isFallbackRail = event.target.matches('[data-js="collection-carousel-fallback"]');
        const fallback = panel.querySelector('[data-js="collection-carousel-fallback"]');

        // Primary rail empty and an untried fallback profile exists?
        // Reveal + hydrate it (the title swaps later, once it has
        // results). Do NOT do this when the fallback itself emptied.
        if (!isFallbackRail && fallback) {
          // Hide the (empty) primary Searchspring host.
          if (event.target.matches('athos-carousel')) {
            event.target.setAttribute('hidden', '');
          }
          // Reveal the fallback skeletons + rail, then hydrate. The
          // tab title is swapped later, on the fallback's
          // carousel:initialised, so an empty fallback never flashes a
          // title before it hides.
          const fallbackSkeletons = skeletonsFor(fallback);
          if (fallbackSkeletons) fallbackSkeletons.removeAttribute('hidden');
          fallback.removeAttribute('hidden');
          if (!panel.hasAttribute('hidden')) {
            requestAnimationFrame(() => initRailsIn(panel));
          }
          return;
        }

        // No fallback (or the fallback itself emptied) — hide tab +
        // panel and roll over.
        panel.setAttribute('hidden', '');
        const tab = tabFor(panel);
        const tabHadFocus = tab === document.activeElement;
        if (tab) tab.setAttribute('hidden', '');

        const remaining = tabs.filter((t) => !t.hasAttribute('hidden'));
        if (remaining.length === 0) {
          section.setAttribute('hidden', '');
          return;
        }
        const activeTab = tabs.find((t) => t.getAttribute('aria-selected') === 'true');
        if (activeTab && activeTab.hasAttribute('hidden')) {
          activate(remaining[0], { focus: tabHadFocus, source: 'failover' });
        }
      });

      // Catch any rails that initialised before this script ran.
      section.querySelectorAll('athos-carousel[data-initialised="true"]').forEach((rail) => {
        const panel = rail.closest('[data-js="collection-carousel-panel"]');
        if (!panel) return;
        const skeletons = skeletonsFor(rail);
        if (skeletons) skeletons.setAttribute('hidden', '');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-subcollection-links"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('.subcollection-links-container');

    containers.forEach((container) => {
      const list = container.querySelector('.subcollection-links');
      const wrapper = container.querySelector('.subcollection-links-wrapper');

      if (!list || !wrapper) return;

      const checkScroll = () => {
        const tolerance = 2;
        const canScrollRight = list.scrollWidth > list.clientWidth + list.scrollLeft + tolerance;
        const canScrollLeft = list.scrollLeft > tolerance;

        wrapper.setAttribute('data-can-scroll-right', canScrollRight);
        wrapper.setAttribute('data-can-scroll-left', canScrollLeft);
      };

      checkScroll();

      list.addEventListener('scroll', checkScroll, { passive: true });
      window.addEventListener('resize', checkScroll, { passive: true });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  /**
   * Animate a FAQ answer panel open or closed by transitioning its height
   * between 0 and its natural height. When motion is reduced we snap instead.
   *
   * @param {HTMLElement} panel - The `[data-js="faq-accordion-content"]` wrapper.
   * @param {boolean} open - Whether the panel is being opened.
   * @returns {void}
   */
  function toggleFaqPanel(panel, open) {
    const reduce = !!(window.themeUtils && window.themeUtils.prefersReducedMotion);
    if (reduce) {
      panel.style.height = open ? 'auto' : '0px';
      return;
    }

    panel.setAttribute('data-animating', '');
    panel.style.height = (open ? 0 : panel.scrollHeight) + 'px';
    // Force reflow so the browser registers the start height before we animate.
    void panel.offsetHeight;
    const target = open ? panel.scrollHeight : 0;
    requestAnimationFrame(() => {
      panel.style.height = target + 'px';
    });

    const onEnd = (event) => {
      if (event.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onEnd);
      panel.removeAttribute('data-animating');
      panel.style.height = open ? 'auto' : '0px';
    };
    panel.addEventListener('transitionend', onEnd);
  }

  /**
   * Initialise one FAQ section: accordion toggles, sticky-nav smooth scroll,
   * and scroll-spy that highlights the nav link for the group in view.
   *
   * @param {HTMLElement} root - The `[data-js="faq-section"]` container.
   * @returns {void}
   */
  function initialiseFaqSection(root) {
    if (root.dataset.initialised === 'true') return;
    root.dataset.initialised = 'true';

    const navLinks = Array.from(root.querySelectorAll('[data-js="faq-nav-link"]'));
    const groups = Array.from(root.querySelectorAll('[data-js="faq-group"]'));

    /**
     * @param {HTMLElement | null} activeLink
     * @returns {void}
     */
    function setActiveNav(activeLink) {
      navLinks.forEach((link) => {
        link.dataset.active = link === activeLink ? 'true' : 'false';
      });
    }

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-js="faq-accordion-button"]');
      if (!button) return;
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      if (panel) toggleFaqPanel(panel, !isOpen);
    });

    navLinks.forEach((link) => {
      link.addEventListener('click', () => {
        const target = document.getElementById(link.dataset.target);
        if (!target) return;
        setActiveNav(link);
        const behaviour = window.themeUtils && window.themeUtils.prefersReducedMotion ? 'auto' : 'smooth';
        const top = target.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top, behavior: behaviour });
      });
    });

    if (groups.length > 0 && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const link = navLinks.find((item) => item.dataset.target === entry.target.id);
            if (link) setActiveNav(link);
          });
        },
        { rootMargin: '-100px 0px -70% 0px', threshold: 0 }
      );
      groups.forEach((group) => observer.observe(group));
    }

    setActiveNav(navLinks[0] || null);
  }

  document.querySelectorAll('[data-js="faq-section"]:not([data-initialised="true"])').forEach(initialiseFaqSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const form = document.querySelector('[data-newsletter-form]');
    if (!form) return;

    const params = new URLSearchParams(window.location.search);
    const isNewsletterReturn = params.get('customer_posted') === 'true';
    const banner = form.querySelector('[data-newsletter-feedback="success"]');
    const serverSuccess = banner ? !banner.hidden : false;

    if (!isNewsletterReturn && !serverSuccess) return;

    if (banner) banner.hidden = true;

    const toast = document.querySelector('[data-newsletter-toast]');
    if (toast) {
      document.body.appendChild(toast);
      toast.hidden = false;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          toast.dataset.visible = 'true';
        });
      });

      window.setTimeout(() => {
        const remove = () => {
          toast.hidden = true;
        };
        toast.addEventListener('transitionend', remove, { once: true });
        toast.dataset.visible = 'false';
        window.setTimeout(remove, 400);
      }, 4000);
    }

    params.delete('customer_posted');
    params.delete('form_type');
    params.delete('contact[tags]');
    params.delete('contact[id]');
    const query = params.toString();
    const cleanUrl = window.location.pathname + (query ? '?' + query : '');
    window.history.replaceState({}, '', cleanUrl);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    'use strict';
    const { emit, on, throttle } = window.themeUtils || {};
    if (!emit) return;

    const header = document.querySelector('.header');
    if (!header) return;

    const announcementBar = document.querySelector('.announcement-bar');
    const overlay = document.querySelector('[data-page-overlay]');
    const desktopNav = header.querySelector('[data-header-menu-desktop]');
    const mobileToggle = header.querySelector('[data-mobile-menu-toggle]');
    const isHomepage = document.body.classList.contains('template-index');

    /* The bar's height doubles as the scroll threshold for the header's
       stuck/transparent state; the ResizeObserver below keeps it current. */
    let abHeight = announcementBar ? announcementBar.offsetHeight : 0;

    const setHeaderHeight = () => {
      const height = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${Math.max(0, Math.floor(height))}px`);
      abHeight = announcementBar ? announcementBar.offsetHeight : 0;
      document.documentElement.style.setProperty('--announcement-bar-height', `${Math.max(0, Math.floor(abHeight))}px`);
    };

    setHeaderHeight();

    const throttledSetHeaderHeight = throttle ? throttle(setHeaderHeight) : setHeaderHeight;
    window.addEventListener('resize', throttledSetHeaderHeight);

    if (window.ResizeObserver) {
      const ro = new ResizeObserver(setHeaderHeight);
      ro.observe(header);
      if (announcementBar) ro.observe(announcementBar);
    }

    const STICKY_CLASS = 'is-sticky';
    const HOVER_CLASS = 'is-hover';
    const SCROLLED_CLASS = 'is-scrolled';

    const surfaces = window.themeUtils.surfaces;
    let isSticky = !isHomepage;
    let revealed = false;

    /**
     * Apply or remove the header's stuck state: opaque header, pinned
     * announcement bar, and the header:sticky-change broadcast. The bar stays
     * pinned for the whole stuck range, so the reveal can slide the header over
     * it without exposing a gap.
     * @param {boolean} sticky - Whether the header is scrolled past the bar
     */
    const setStickyState = (sticky) => {
      if (sticky === isSticky) return;
      isSticky = sticky;

      if (!sticky && isHomepage) {
        header.dataset.snap = 'true';
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            delete header.dataset.snap;
          });
        });
      }

      header.classList.toggle(STICKY_CLASS, sticky);
      if (announcementBar) announcementBar.classList.toggle(STICKY_CLASS, sticky);
      emit('header:sticky-change', { isSticky: sticky });

      if (sticky) {
        header.classList.remove(HOVER_CLASS);
      }
    };

    /**
     * Toggle the scroll-up reveal: slides the header down to expose the pinned
     * announcement bar and offsets downstream sticky sub-bars by the bar's
     * height so they clear it. The bar is pinned by the stuck state, so the
     * reveal only moves the header.
     * @param {boolean} on - Whether the announcement bar is revealed
     */
    const setRevealed = (on) => {
      if (on === revealed) return;
      revealed = on;
      header.classList.toggle(SCROLLED_CLASS, on);
      document.documentElement.style.setProperty('--header-offset', on ? `${abHeight}px` : '0px');
    };

    document.documentElement.style.setProperty('--header-offset', '0px');

    let covered = false;
    let coverTimer = null;

    /**
     * Flag the announcement bar as sitting underneath the pinned header. The bar
     * is hidden while covered so a dark banner colour cannot bleed through the
     * header's background fade; the retract pass delays the hide until the
     * header has slid back over it, leaving no uncovered strip mid-slide.
     * @param {boolean} on - Whether the header now covers the bar
     * @param {number} [delay] - Milliseconds to wait before hiding
     * @returns {void}
     */
    const setCovered = (on, delay) => {
      if (!announcementBar || on === covered) return;
      covered = on;

      if (coverTimer !== null) {
        clearTimeout(coverTimer);
        coverTimer = null;
      }

      if (!on) {
        delete announcementBar.dataset.covered;
        return;
      }

      if (delay) {
        coverTimer = setTimeout(() => {
          announcementBar.dataset.covered = 'true';
          coverTimer = null;
        }, delay);
        return;
      }

      announcementBar.dataset.covered = 'true';
    };

    if (announcementBar) {
      const UNSTICK_HYSTERESIS = 8;
      const REVEAL_DELTA = 6;
      /* Matches --motion-drawer, the header's transform duration. */
      const RETRACT_MS = 220;
      let revealAnchor = window.scrollY;

      const onScroll = throttle(() => {
        if (document.documentElement.classList.contains('lock-scroll')) return;
        const y = window.scrollY;
        const wasRevealed = revealed;

        if (isHomepage) {
          const unstickAt = Math.max(0, abHeight - UNSTICK_HYSTERESIS);
          if (!isSticky && y >= abHeight) setStickyState(true);
          else if (isSticky && y <= unstickAt) setStickyState(false);
        }

        if (isSticky && y > abHeight) {
          if (y <= revealAnchor - REVEAL_DELTA) {
            setRevealed(true);
            revealAnchor = y;
          } else if (y >= revealAnchor + REVEAL_DELTA) {
            setRevealed(false);
            revealAnchor = y;
          }
        } else {
          setRevealed(false);
          revealAnchor = y;
        }

        setCovered(y >= abHeight && !revealed, wasRevealed ? RETRACT_MS : 0);
      });

      window.addEventListener('scroll', onScroll, { passive: true });
    }

    setCovered(window.scrollY >= abHeight, 0);

    if (isHomepage && announcementBar) {
      setStickyState(window.scrollY >= abHeight);
    } else if (!isHomepage) {
      header.classList.add(STICKY_CLASS);
      if (announcementBar) announcementBar.classList.add(STICKY_CLASS);
      emit('header:sticky-change', { isSticky: true });
    }

    /**
     * Add opaque hover state (only when not already sticky).
     */
    const addHover = () => {
      if (isSticky) return;
      if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;
      header.classList.add(HOVER_CLASS);
      if (announcementBar) announcementBar.classList.add('is-hover');
    };

    /**
     * Remove opaque hover state.
     * Checks related target to avoid flicker when moving between header/announcement/desktop-menu.
     * @param {MouseEvent} event
     */
    let _desktopMenuEl;
    const getDesktopMenu = () => _desktopMenuEl || (_desktopMenuEl = document.querySelector('[data-desktop-menu]'));

    const removeHover = (event) => {
      const related = event?.relatedTarget;
      const dm = getDesktopMenu();

      if (
        related &&
        (header.contains(related) ||
          (announcementBar && announcementBar.contains(related)) ||
          (dm && dm.contains(related)) ||
          (overlay && overlay.contains(related)))
      ) {
        return;
      }

      if (dm && dm.dataset.state === 'open') return;

      if (!isSticky) {
        header.classList.remove(HOVER_CLASS);
        if (announcementBar) announcementBar.classList.remove('is-hover');
      }
    };

    if (isHomepage) {
      header.addEventListener('mouseenter', addHover);
      header.addEventListener('mouseleave', removeHover);

      const megaEl = getDesktopMenu();
      if (megaEl && window.MutationObserver) {
        const megaStateObserver = new MutationObserver(() => {
          if (megaEl.dataset.state === 'open') return;
          if (header.matches(':hover')) return;
          if (announcementBar && announcementBar.matches(':hover')) return;
          removeHover();
        });
        megaStateObserver.observe(megaEl, { attributes: true, attributeFilter: ['data-state'] });
      }
    }

    on('announcement:hover', (e) => {
      if (e.detail.isHover) {
        addHover();
      }
    });

    if (announcementBar && isHomepage) {
      announcementBar.addEventListener('mouseenter', addHover);
      announcementBar.addEventListener('mouseleave', removeHover);
    }

    if (desktopNav) {
      /** @returns {(HTMLElement & {show?: Function, scheduleHide?: Function})|null} */
      const getMega = () => document.getElementById('desktop-menu-panel');

      desktopNav.addEventListener('pointerover', (event) => {
        const link = event.target.closest('a[data-menu-id]');
        const mega = getMega();
        if (!link || !mega || typeof mega.show !== 'function') return;
        mega.show(link.dataset.menuId, { intent: true });
      });

      desktopNav.addEventListener('focusin', (event) => {
        const link = event.target.closest('a[data-menu-id]');
        const mega = getMega();
        if (!link || !mega || typeof mega.show !== 'function') return;
        mega.show(link.dataset.menuId, {});
      });

      desktopNav.addEventListener('pointerleave', () => {
        const mega = getMega();
        if (mega && typeof mega.scheduleHide === 'function') mega.scheduleHide();
      });

      desktopNav.addEventListener('focusout', (event) => {
        const next = event.relatedTarget;
        const mega = getMega();
        if (!mega) return;
        if (next && (desktopNav.contains(next) || mega.contains(next))) return;
        if (typeof mega.scheduleHide === 'function') mega.scheduleHide();
      });
    }

    if (mobileToggle && surfaces) {
      const labelOpen = mobileToggle.dataset.labelOpen || mobileToggle.getAttribute('aria-label');
      const labelClose = mobileToggle.dataset.labelClose || labelOpen;

      mobileToggle.addEventListener('click', () => {
        if (surfaces.current() === 'mobile-menu') {
          surfaces.close('mobile-menu');
        } else {
          surfaces.open('mobile-menu');
        }
      });

      on('mobile-menu:toggle', (e) => {
        const isOpen = Boolean(e.detail && e.detail.isOpen);
        mobileToggle.setAttribute('aria-expanded', String(isOpen));
        mobileToggle.setAttribute('aria-label', isOpen ? labelClose : labelOpen);
      });
    }

    if (surfaces) {
      let suppressFocusOpen = false;

      /**
       * Open the current breakpoint's search surface (no-op if already open).
       * @returns {void}
       */
      const openSearch = () => {
        const surface = window.innerWidth < 768 ? 'mobile-search' : 'desktop-search';
        if (surfaces.current() === surface) return;
        surfaces.open(surface);
      };

      /**
       * Focusing a header search input opens search only when the focus is a
       * genuine user gesture — not a dialog focus-restore or window refocus.
       * @returns {void}
       */
      const onSearchInputFocus = () => {
        if (suppressFocusOpen) {
          suppressFocusOpen = false;
          return;
        }
        openSearch();
      };

      header.querySelectorAll('[data-search-trigger]').forEach((trigger) => {
        if (trigger.tagName === 'INPUT') {
          trigger.addEventListener('focus', onSearchInputFocus);
        } else {
          trigger.addEventListener('click', openSearch);
        }
      });

      window.addEventListener('focus', () => {
        suppressFocusOpen = true;
      });
      window.addEventListener(
        'pointerdown',
        () => {
          suppressFocusOpen = false;
        },
        true
      );
      window.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'Tab') suppressFocusOpen = false;
        },
        true
      );

      header.querySelectorAll('[data-search-bar]').forEach((bar) => {
        bar.addEventListener('click', (event) => {
          if (event.target.closest('input')) return;
          const input = bar.querySelector('input');
          if (input) input.focus();
        });
      });

      on('search:open', () => {
        header.classList.add('is-search-active');
        if (announcementBar) announcementBar.classList.add('is-search-active');
      });
      on('search:close', () => {
        header.classList.remove('is-search-active');
        if (announcementBar) announcementBar.classList.remove('is-search-active');
        suppressFocusOpen = true;
      });
    }

    const shopifyAccount = header.querySelector('shopify-account');
    if (shopifyAccount) {
      const handleAccountOpen = () => {
        header.classList.add(HOVER_CLASS);
        if (announcementBar) announcementBar.classList.add('is-hover');
      };

      const handleAccountClose = () => {
        header.classList.remove(HOVER_CLASS);
        if (announcementBar) announcementBar.classList.remove('is-hover');
      };

      shopifyAccount.addEventListener('open', handleAccountOpen);
      shopifyAccount.addEventListener('close', handleAccountClose);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-page"] && !Shopify.designMode) return;
  try {
    
  /**
   * Lower-cases text and strips accents and repeated whitespace so search matching ignores them.
   * @param {string} value - Text to normalise.
   * @returns {string} The normalised text.
   */
  function normaliseHelpText(value) {
    return value
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /**
   * Whether animated scrolling should be skipped for this visitor.
   * @returns {boolean} True when reduced motion is preferred.
   */
  function helpPrefersReducedMotion() {
    if (window.themeUtils && typeof window.themeUtils.prefersReducedMotion === 'boolean') {
      return window.themeUtils.prefersReducedMotion;
    }
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /**
   * Shows one FAQ group (or all of them) and marks the matching filter chip as active.
   * @param {HTMLElement} root - The help page root.
   * @param {string} groupId - A group block id, or `all`.
   * @returns {void}
   */
  function showHelpFaqGroup(root, groupId) {
    root.querySelectorAll('[data-js="help-page-faq-group"]').forEach((group) => {
      group.hidden = groupId !== 'all' && group.dataset.group !== groupId;
    });
    root.querySelectorAll('[data-js="help-page-faq-filter"]').forEach((chip) => {
      const active = chip.dataset.group === groupId;
      chip.dataset.active = active ? 'true' : 'false';
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  /**
   * Opens an FAQ answer, makes sure its group is visible, and scrolls it into view.
   * @param {HTMLElement} root - The help page root.
   * @param {HTMLDetailsElement} item - The answer to reveal.
   * @returns {void}
   */
  function revealHelpFaqItem(root, item) {
    const group = item.closest('[data-js="help-page-faq-group"]');
    if (group && group.hidden) showHelpFaqGroup(root, 'all');
    item.open = true;
    item.dataset.highlighted = 'true';
    window.setTimeout(() => {
      item.dataset.highlighted = 'false';
    }, 1600);
    item.scrollIntoView({ behavior: helpPrefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    const summary = item.querySelector('summary');
    if (summary) summary.focus({ preventScroll: true });
  }

  /**
   * Opens the FAQ answer or group named in the URL hash, so answers can be linked to directly.
   * @param {HTMLElement} root - The help page root.
   * @returns {void}
   */
  function openHelpTargetFromHash(root) {
    const id = decodeURIComponent(window.location.hash.slice(1));
    if (!id || id === 'live-chat') return;
    const target = document.getElementById(id);
    if (!target || !root.contains(target)) return;
    if (target.matches('[data-js="help-page-faq-item"]')) {
      revealHelpFaqItem(root, target);
    } else if (target.matches('[data-js="help-page-faq-group"]')) {
      showHelpFaqGroup(root, 'all');
      target.scrollIntoView({ block: 'start' });
    }
  }

  /**
   * Appends text to an element, wrapping every occurrence of the search terms in `<mark>`.
   * @param {HTMLElement} container - Element to append to.
   * @param {string} text - Text to append.
   * @param {string[]} terms - Normalised search terms.
   * @returns {void}
   */
  function appendHelpHighlightedText(container, text, terms) {
    const pattern = terms.map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
    if (!pattern) {
      container.append(text);
      return;
    }
    text.split(new RegExp(`(${pattern})`, 'gi')).forEach((part, index) => {
      if (!part) return;
      if (index % 2 === 1) {
        const mark = document.createElement('mark');
        mark.textContent = part;
        container.append(mark);
      } else {
        container.append(part);
      }
    });
  }

  /**
   * Wires the hub search: filters the page's FAQ answers as the visitor types and opens the chosen answer.
   * @param {HTMLElement} root - The help page root.
   * @returns {void}
   */
  function initialiseHelpSearch(root) {
    const search = root.querySelector('[data-js="help-page-search"]');
    if (!search) return;
    const input = search.querySelector('[data-js="help-page-search-input"]');
    const results = search.querySelector('[data-js="help-page-search-results"]');
    const status = search.querySelector('[data-js="help-page-search-status"]');
    const resultTemplate = search.querySelector('[data-js="help-page-search-result"]');
    const emptyTemplate = search.querySelector('[data-js="help-page-search-empty"]');
    if (!input || !results || !resultTemplate || !emptyTemplate) return;

    const entries = Array.from(root.querySelectorAll('[data-js="help-page-faq-item"]')).map((item) => {
      const summary = item.querySelector('summary');
      const answer = item.querySelector('.help-page__faq-answer');
      const question = summary ? summary.textContent.trim() : '';
      return {
        item,
        question,
        group: item.dataset.group || '',
        questionText: normaliseHelpText(question),
        answerText: normaliseHelpText(answer ? answer.textContent : ''),
      };
    });

    /**
     * Scores an entry: question matches outrank answer matches, and every term must match somewhere.
     * @param {Object} entry - Indexed FAQ entry with normalised `questionText` and `answerText`.
     * @param {string[]} terms - Normalised search terms.
     * @returns {number} Score, or -1 when a term is missing.
     */
    const scoreEntry = (entry, terms) =>
      terms.reduce((total, term) => {
        if (total < 0) return total;
        if (entry.questionText.includes(term)) return total + 3;
        if (entry.answerText.includes(term)) return total + 1;
        return -1;
      }, 0);

    /**
     * Renders the result list for the current query.
     * @returns {void}
     */
    const render = () => {
      const terms = normaliseHelpText(input.value)
        .split(' ')
        .filter((term) => term.length > 1);
      results.replaceChildren();
      if (!terms.length) {
        results.hidden = true;
        if (status) status.textContent = '';
        return;
      }
      const matches = entries
        .map((entry) => ({ entry, score: scoreEntry(entry, terms) }))
        .filter((match) => match.score > 0)
        .sort((first, second) => second.score - first.score)
        .slice(0, 8);

      if (matches.length) {
        matches.forEach(({ entry }) => {
          const result = resultTemplate.content.firstElementChild.cloneNode(true);
          result.dataset.index = String(entries.indexOf(entry));
          const group = result.querySelector('[data-js="help-page-search-result-group"]');
          const question = result.querySelector('[data-js="help-page-search-result-question"]');
          if (group) group.textContent = entry.group;
          if (question) appendHelpHighlightedText(question, entry.question, terms);
          results.append(result);
        });
      } else {
        results.append(emptyTemplate.content.cloneNode(true));
      }
      if (status && status.dataset.template) {
        status.textContent = status.dataset.template.replace('[count]', String(matches.length));
      }
      results.hidden = false;
    };

    input.addEventListener('input', render);
    input.addEventListener('focus', render);
    input.addEventListener('keydown', (event) => {
      const first = results.querySelector('.help-page__search-result');
      if (event.key === 'Enter') {
        event.preventDefault();
        if (first) first.click();
      } else if (event.key === 'Escape') {
        input.value = '';
        render();
      } else if (event.key === 'ArrowDown' && first) {
        event.preventDefault();
        first.focus();
      }
    });

    results.addEventListener('keydown', (event) => {
      const current = document.activeElement;
      if (!current || !results.contains(current)) return;
      if (event.key === 'ArrowDown' && current.nextElementSibling) {
        event.preventDefault();
        current.nextElementSibling.focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        (current.previousElementSibling || input).focus();
      }
    });

    results.addEventListener('click', (event) => {
      const result = event.target.closest('.help-page__search-result');
      if (!result) return;
      const entry = entries[Number(result.dataset.index)];
      if (!entry) return;
      results.hidden = true;
      window.history.replaceState(null, '', `#${entry.item.id}`);
      revealHelpFaqItem(root, entry.item);
    });

    document.addEventListener('click', (event) => {
      if (!search.contains(event.target)) results.hidden = true;
    });
  }

  /**
   * Builds the numbered contents list for long page content (terms, privacy) from its headings.
   * @param {HTMLElement} root - The help page root.
   * @returns {void}
   */
  function initialiseHelpContents(root) {
    const contents = root.querySelector('[data-js="help-page-contents"]');
    const source = root.querySelector('[data-js="help-page-contents-source"]');
    if (!contents || !source) return;
    let headings = Array.from(source.querySelectorAll('h2'));
    if (headings.length < 2) headings = Array.from(source.querySelectorAll('h3'));
    if (headings.length < 2) return;
    const list = contents.querySelector('ol');
    const used = new Set();
    headings.forEach((heading) => {
      let id = heading.id || normaliseHelpText(heading.textContent).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
      while (used.has(id) || (!heading.id && document.getElementById(id))) id = `${id}-1`;
      used.add(id);
      heading.id = id;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = heading.textContent.replace(/^\s*\d+[.)]\s*/, '').trim();
      item.append(link);
      list.append(item);
    });
    contents.hidden = false;
  }

  /**
   * Highlights the sidebar link for the block currently at the top of the viewport.
   * @param {HTMLElement} root - The help page root.
   * @returns {void}
   */
  function initialiseHelpSidebar(root) {
    const links = Array.from(root.querySelectorAll('[data-js="help-page-sidebar-link"]'));
    if (!links.length) return;
    const targets = links.map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))));

    /**
     * Marks the last block whose top has passed the upper third of the viewport.
     * @returns {void}
     */
    const update = () => {
      const line = window.innerHeight * 0.3;
      let current = -1;
      targets.forEach((target, index) => {
        if (target && target.offsetParent !== null && target.getBoundingClientRect().top <= line) current = index;
      });
      links.forEach((link, index) => {
        if (index === current) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    const onScroll =
      window.themeUtils && typeof window.themeUtils.throttle === 'function' ? window.themeUtils.throttle(update) : update;
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  /**
   * Initialise one help page.
   * @param {HTMLElement} root - The `[data-js="help-page"]` element.
   * @returns {void}
   */
  function initialiseHelpPage(root) {
    root.dataset.initialised = 'true';
    root.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-js="help-page-faq-filter"]');
      if (chip) showHelpFaqGroup(root, chip.dataset.group);
    });
    initialiseHelpSearch(root);
    initialiseHelpContents(root);
    initialiseHelpSidebar(root);
    openHelpTargetFromHash(root);
  }

  /**
   * Initialise every help page not yet initialised (the theme editor re-renders sections in place).
   * @returns {void}
   */
  function initialiseHelpPages() {
    document.querySelectorAll('[data-js="help-page"]:not([data-initialised="true"])').forEach(initialiseHelpPage);
  }

  initialiseHelpPages();
  document.addEventListener('shopify:section:load', initialiseHelpPages);
  window.addEventListener('hashchange', () => {
    document.querySelectorAll('[data-js="help-page"]').forEach(openHelpTargetFromHash);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initBanners = () => {
      const banners = document.querySelectorAll('[data-js="hero-banner"]:not([data-initialised="true"])');

      banners.forEach((banner) => {
        banner.setAttribute('data-initialised', 'true');
        const slides = banner.querySelectorAll('[data-js="hero-slide"]');
        if (slides.length === 0) return;

        const autoSlideEnabled = banner.dataset.autoSlide === 'true' && slides.length > 1;
        const slideInterval = parseInt(banner.dataset.slideInterval, 10) || 5000;
        const pauseOnHover = banner.dataset.pauseHover === 'true';

        let currentSlideIndex = 0;
        let intervalId = null;
        let isHovering = false;
        let isTouching = false;
        let touchStartX = 0;
        let touchEndX = 0;
        const swipeThreshold = 50;
        const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        const desktopQuery = window.matchMedia('(min-width: 768px)');

        /**
         * Returns 'desktop' or 'mobile' based on current viewport.
         * @returns {'desktop' | 'mobile'}
         */
        const currentViewport = () => (desktopQuery.matches ? 'desktop' : 'mobile');

        /**
         * Ensures a `<source>` element exists on a video and triggers load.
         * @param {HTMLVideoElement} video
         */
        const attachSource = (video) => {
          if (video.querySelector('source')) return;
          const src = video.dataset.src;
          if (!src) return;
          const source = document.createElement('source');
          source.src = src;
          source.type = video.dataset.type || 'video/mp4';
          video.appendChild(source);
          video.load();
        };

        /**
         * Removes all `<source>` children and releases the underlying network resource.
         * @param {HTMLVideoElement} video
         */
        const detachSource = (video) => {
          const hadSource = video.querySelector('source') !== null;
          if (!hadSource) return;
          video.pause();
          video.removeAttribute('src');
          while (video.firstChild) video.removeChild(video.firstChild);
          // `.load()` on an empty <video> cancels any in-flight download.
          video.load();
        };

        /**
         * Loads + plays the active slide's video (matching viewport only);
         * unloads sources from any video that is either inactive or the wrong viewport.
         * @param {number} activeIndex
         */
        const syncVideos = (activeIndex) => {
          const viewport = currentViewport();
          slides.forEach((slide, i) => {
            const videos = slide.querySelectorAll('video[data-js="hero-video"]');
            videos.forEach((video) => {
              const matches = i === activeIndex && video.dataset.viewport === viewport;
              if (matches) {
                attachSource(video);
                const playPromise = video.play();
                if (playPromise !== undefined) playPromise.catch(() => {});
              } else {
                detachSource(video);
              }
            });
          });
        };

        /**
         * Checks if a slide is configured to display a video in the current viewport.
         * @param {Element} slide
         * @returns {boolean}
         */
        const slideHasActiveVideo = (slide) => {
          const viewport = currentViewport();
          return slide.querySelector(`video[data-js="hero-video"][data-viewport="${viewport}"]`) !== null;
        };

        /**
         * Hydrates a slide's deferred media on first activation. Non-first
         * slides ship with their <picture> wrapped in a <template> and their
         * LQIP stored in data-attrs so nothing is fetched until the user
         * actually navigates to the slide.
         * @param {Element} slide
         */
        const hydrateSlide = (slide) => {
          const media = slide.querySelector('.hero-banner__media');
          if (!media || media.dataset.hydrated === 'true') return;

          // Promote LQIP data-attrs to CSS custom properties so the
          // blurred background paints while the full media loads.
          const { lqipDesktop, lqipMobile } = media.dataset;
          if (lqipDesktop) media.style.setProperty('--lqip-desktop', `url('${lqipDesktop}')`);
          if (lqipMobile) media.style.setProperty('--lqip-mobile', `url('${lqipMobile}')`);

          // Move any <template> contents (the <picture>) into the DOM so
          // the browser starts fetching the full image.
          const template = media.querySelector('template[data-js="hero-slide-template"]');
          if (template) {
            media.insertBefore(template.content.cloneNode(true), template);
            template.remove();
          }

          media.dataset.hydrated = 'true';
        };

        /**
         * Updates the DOM to show the active slide and hide others
         * @param {number} index - Index of the slide to show
         */
        const showSlide = (index) => {
          hydrateSlide(slides[index]);

          slides.forEach((slide, i) => {
            const isActive = i === index;
            const cta = slide.querySelector('.hero-banner__cta');

            slide.setAttribute('data-active', isActive ? 'true' : 'false');
            slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
            if (cta) cta.setAttribute('tabindex', isActive ? '0' : '-1');
          });

          syncVideos(index);

          // Re-evaluate auto slide based on the new slide's content
          if (autoSlideEnabled) {
            if (slideHasActiveVideo(slides[index])) {
              stopAutoSlide();
            } else if (!isHovering && !isTouching) {
              startAutoSlide();
            }
          }
        };

        /**
         * Navigates to the next slide
         */
        const nextSlide = () => {
          currentSlideIndex = (currentSlideIndex + 1) % slides.length;
          showSlide(currentSlideIndex);
        };

        /**
         * Navigates to the previous slide
         */
        const prevSlide = () => {
          currentSlideIndex = (currentSlideIndex - 1 + slides.length) % slides.length;
          showSlide(currentSlideIndex);
        };

        /**
         * Starts the auto-slide interval, respecting reduced-motion and active interactions.
         */
        const startAutoSlide = () => {
          if (!autoSlideEnabled) return;
          if (reducedMotionQuery.matches) return;
          if (isHovering || isTouching) return;
          if (slideHasActiveVideo(slides[currentSlideIndex])) return;

          if (intervalId === null) {
            intervalId = setInterval(nextSlide, slideInterval);
          }
        };

        /**
         * Stops the auto-slide interval
         */
        const stopAutoSlide = () => {
          if (intervalId !== null) {
            clearInterval(intervalId);
            intervalId = null;
          }
        };

        if (pauseOnHover) {
          banner.addEventListener('mouseenter', () => {
            isHovering = true;
            stopAutoSlide();
          });
          banner.addEventListener('mouseleave', () => {
            isHovering = false;
            startAutoSlide();
          });
          banner.addEventListener('focusin', () => {
            isHovering = true;
            stopAutoSlide();
          });
          banner.addEventListener('focusout', () => {
            isHovering = false;
            startAutoSlide();
          });
        }

        // Keyboard navigation
        banner.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            prevSlide();
          } else if (e.key === 'ArrowRight') {
            nextSlide();
          }
        });

        banner.addEventListener(
          'touchstart',
          (e) => {
            touchStartX = e.changedTouches[0].screenX;
            isTouching = true;
            stopAutoSlide();
          },
          { passive: true }
        );

        banner.addEventListener(
          'touchend',
          (e) => {
            touchEndX = e.changedTouches[0].screenX;
            isTouching = false;
            handleSwipe();
            startAutoSlide();
          },
          { passive: true }
        );

        /**
         * Handles swipe logic based on touch start and end positions
         */
        const handleSwipe = () => {
          const diff = touchEndX - touchStartX;
          if (Math.abs(diff) > swipeThreshold) {
            if (diff < 0) {
              nextSlide();
            } else {
              prevSlide();
            }
          }
        };

        // Re-sync videos when crossing the mobile/desktop breakpoint so the
        // correct source is loaded and the wrong one is released.
        const onViewportChange = () => syncVideos(currentSlideIndex);
        if (typeof desktopQuery.addEventListener === 'function') {
          desktopQuery.addEventListener('change', onViewportChange);
        } else if (typeof desktopQuery.addListener === 'function') {
          desktopQuery.addListener(onViewportChange);
        }

        // Initial load: attach source to the first slide's matching video only.
        syncVideos(currentSlideIndex);
        // If the first slide is a video, auto-slide stays paused until navigation.
        if (!slideHasActiveVideo(slides[currentSlideIndex])) {
          startAutoSlide();
        }
      });
    };

    document.addEventListener('DOMContentLoaded', initBanners);
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      initBanners();
    }
    document.addEventListener('shopify:section:load', initBanners);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["information-policy"]) return;
  try {
    
  /**
   * Wire up the policy modals for one section: open on trigger click, close on
   * the close button, backdrop click, or Escape. Scroll is locked via the
   * shared themeUtils lock while a modal is open, and focus moves to the modal
   * on open and returns to the trigger on close.
   *
   * @param {HTMLElement} root - The section root (`[data-js="information-policy"]`).
   * @returns {void}
   */
  function initInformationPolicy(root) {
    if (root.dataset.initialised === 'true') return;
    root.dataset.initialised = 'true';

    let lastTrigger = null;

    /**
     * @param {string} id - The modal element id.
     * @returns {HTMLElement | null}
     */
    function backdropFor(id) {
      return root.querySelector('[data-js="policy-backdrop"][data-modal-id="' + id + '"]');
    }

    /**
     * @param {HTMLElement} modal
     * @returns {void}
     */
    function openModal(modal) {
      const backdrop = backdropFor(modal.id);
      modal.dataset.state = 'open';
      if (backdrop) backdrop.dataset.state = 'open';
      if (window.themeUtils) window.themeUtils.lockScroll(modal.id);
      const closeButton = modal.querySelector('[data-js="policy-close"]');
      if (closeButton) closeButton.focus();
    }

    /**
     * @param {HTMLElement} modal
     * @returns {void}
     */
    function closeModal(modal) {
      const backdrop = backdropFor(modal.id);
      modal.dataset.state = 'closed';
      if (backdrop) backdrop.dataset.state = 'closed';
      if (window.themeUtils) window.themeUtils.unlockScroll(modal.id);
      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-js="policy-trigger"]');
      if (trigger) {
        const modal = document.getElementById(trigger.dataset.modalId);
        if (modal) {
          lastTrigger = trigger;
          openModal(modal);
        }
        return;
      }

      const closeButton = event.target.closest('[data-js="policy-close"]');
      if (closeButton) {
        const modal = closeButton.closest('[data-js="policy-modal"]');
        if (modal) closeModal(modal);
        return;
      }

      const backdrop = event.target.closest('[data-js="policy-backdrop"]');
      if (backdrop) {
        const modal = document.getElementById(backdrop.dataset.modalId);
        if (modal) closeModal(modal);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openPanel = root.querySelector('[data-js="policy-modal"][data-state="open"]');
      if (openPanel) closeModal(openPanel);
    });
  }

  document
    .querySelectorAll('[data-js="information-policy"]:not([data-initialised="true"])')
    .forEach(initInformationPolicy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-help-accordion"] && !Shopify.designMode) return;
  try {
    
  /**
   * Handles two concerns for the help accordion:
   * 1. Animated close — intercepts summary clicks to let the CSS
   *    grid-template-rows transition finish before removing [open].
   * 2. Live chat links — delegates clicks on chat links/buttons.
   *
   * @param {Event} event - The click event.
   */
  document.addEventListener('click', (event) => {
    const accordion = event.target.closest('[data-old-help-accordion]');
    if (!accordion) return;

    /* ── Live chat delegation ── */
    const chatLink = event.target.closest('a[href*="live-chat"]');
    const chatButton = event.target.closest('[data-action="trigger-chat"]');

    if (chatLink || chatButton) {
      event.preventDefault();
      if (typeof openChatButtonClick === 'function') {
        openChatButtonClick();
      }
      return;
    }

    /* ── Animated close for <details> ── */
    const summary = event.target.closest('.old-help-accordion__summary');
    if (!summary) return;

    const details = summary.parentElement;
    if (!details || !details.open) return; /* Opening — let native handle */

    event.preventDefault(); /* Closing — we take over */
    const content = details.querySelector('.old-help-accordion__content');
    if (!content) return;

    details.dataset.closing = '';

    /**
     * After the collapse transition ends, remove the open attribute
     * and the data-closing flag so the element is fully closed.
     */
    const onTransitionEnd = (e) => {
      if (e.target !== content) return;
      content.removeEventListener('transitionend', onTransitionEnd);
      delete details.dataset.closing;
      details.removeAttribute('open');
    };

    content.addEventListener('transitionend', onTransitionEnd);

    /* Safety net — if the transition doesn't fire (e.g. reduced-motion) */
    setTimeout(() => {
      if (details.hasAttribute('data-closing')) {
        content.removeEventListener('transitionend', onTransitionEnd);
        delete details.dataset.closing;
        details.removeAttribute('open');
      }
    }, 400);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-help-action-button"] && !Shopify.designMode) return;
  try {
    
  const section = document.querySelector('.old-help-action-section');
  if (section) {
    section.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-action="trigger-chat"]');
      if (!trigger) return;

      event.preventDefault();

      /* openChatButtonClick() is a global function defined in layout/theme.liquid that triggers the INSIDE live chat widget (insideFrontInterface.openChatPane). */
      if (typeof openChatButtonClick === 'function') {
        openChatButtonClick();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-help-action-buttons"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.old-help-actions-section');
    sections.forEach((section) => {
      if (section.dataset.eventsBound) return;
      section.dataset.eventsBound = 'true';

      section.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-action="trigger-chat"]');
        if (!trigger) return;

        event.preventDefault();

        /* openChatButtonClick() is a global function defined in layout/theme.liquid */
        if (typeof openChatButtonClick === 'function') {
          openChatButtonClick();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /**
     * Initialise a product-reviews section: reveal the Yotpo widget once it has
     * rendered, or hide the section if it never does.
     * @param {HTMLElement} section - The section root element.
     * @returns {void}
     */
    function initialiseProductReviews(section) {
      section.dataset.initialised = 'true';

      const skeleton = section.querySelector('[data-js="product-reviews-skeleton"]');
      const widget = section.querySelector('[data-js="product-reviews-widget"]');

      if (!skeleton || !widget) return;

      let giveUpTimeout = null;
      let settled = false;

      /**
       * Whether Yotpo has rendered visible content into the widget container.
       * @returns {boolean}
       */
      function hasRendered() {
        if (widget.classList.contains('yotpo-display-none') || widget.classList.contains('yotpo-hidden')) {
          return false;
        }
        if (window.getComputedStyle(widget).display === 'none') return false;
        // The widget stretches to the skeleton's grid row, so its own height proves
        // nothing. Look for a child that has laid out instead — Yotpo's first child
        // can be a zero-height wrapper or an injected <style>.
        return Array.from(widget.children).some((child) => child.getBoundingClientRect().height > 0);
      }

      /**
       * Poll until Yotpo's own DOM has settled into a visible, non-empty state.
       * @returns {void}
       */
      function revealWhenReady() {
        let attempts = 0;

        const interval = setInterval(() => {
          attempts += 1;

          if (hasRendered()) {
            clearInterval(interval);
            skeleton.dataset.hidden = 'true';

            // The fade is suppressed under reduced motion, so transitionend never fires there.
            if (window.themeUtils && window.themeUtils.prefersReducedMotion) {
              skeleton.dataset.removed = 'true';
              return;
            }

            skeleton.addEventListener(
              'transitionend',
              () => {
                skeleton.dataset.removed = 'true';
              },
              { once: true }
            );
          } else if (attempts >= 100) {
            clearInterval(interval);
            section.dataset.hidden = 'true';
          }
        }, 100);
      }

      /**
       * Hand over to the reveal poll once Yotpo has stamped the widget as loaded.
       * @returns {void}
       */
      function checkLoaded() {
        if (settled) return;
        if (widget.dataset.yotpoElementLoaded !== 'true') return;

        settled = true;
        clearTimeout(giveUpTimeout);
        observer.disconnect();
        revealWhenReady();
      }

      const observer = new MutationObserver(checkLoaded);

      observer.observe(widget, { attributes: true, attributeFilter: ['data-yotpo-element-loaded'] });

      // Yotpo's loader sits in the head and may have stamped the widget before this ran.
      checkLoaded();

      // Yotpo only builds the widget once it nears the viewport, and this section
      // sits well below the fold, so the give-up timer must not start before then.
      const visibility = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          visibility.disconnect();
          if (settled) return;

          giveUpTimeout = setTimeout(() => {
            observer.disconnect();
            section.dataset.hidden = 'true';
          }, 10000);
        },
        { rootMargin: '200px' }
      );

      visibility.observe(section);
    }

    /**
     * Initialise every uninitialised product-reviews section on the page.
     * @returns {void}
     */
    function initialiseAll() {
      document
        .querySelectorAll('[data-js="product-reviews"]:not([data-initialised="true"])')
        .forEach(initialiseProductReviews);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseAll);
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', initialiseAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /**
   * Fetch a product's Yotpo review summary. Resolves to the payload or null; never rejects.
   * @param {string} appKey - The public Yotpo App Key, which doubles as the store id.
   * @param {string} productId - The Shopify numeric product id.
   * @returns {Promise<object | null>}
   */
  async function fetchReviewsSummary(appKey, productId) {
    const endpoint = 'https://api-cdn.yotpo.com/v3/storefront/stores/';
    const url = endpoint + appKey + '/products/' + productId + '/productData?include=reviewsSummary';
    try {
      const response = await fetch(url);
      if (!response.ok) return null;
      const json = await response.json();
      return (json && json.response) || null;
    } catch (err) {
      return null;
    }
  }

  /**
   * Sort topics into the merchandising order, leaving any unrecognised topic in API order behind them.
   * @param {Array<object>} topics
   * @returns {Array<object>}
   */
  function orderReviewsSummaryTopics(topics) {
    // Display order is fixed regardless of how the API orders its topics.
    const order = ['fit', 'material', 'length', 'looks'];
    const rank = (topic) => {
      const index = order.indexOf(topic.topic);
      return index === -1 ? order.length : index;
    };
    return topics.slice().sort((a, b) => rank(a) - rank(b));
  }

  /**
   * Stamp the topic list into the drawer body.
   * @param {HTMLElement} root
   * @param {Array<object>} topics
   * @returns {void}
   */
  function renderReviewsSummaryTopics(root, topics) {
    const list = root.querySelector('[data-js="reviews-summary-topics"]');
    const template = root.querySelector('[data-js="reviews-summary-topic-template"]');
    if (!list || !template) return;

    const coverageTemplate = root.dataset.coverageTemplate || '';
    const fragment = document.createDocumentFragment();

    orderReviewsSummaryTopics(topics).forEach((topic) => {
      const node = template.content.firstElementChild.cloneNode(true);
      node.querySelector('[data-js="reviews-summary-topic-title"]').textContent = topic.displayTopic;
      node.querySelector('[data-js="reviews-summary-topic-text"]').textContent = topic.summary;

      const coverage = node.querySelector('[data-js="reviews-summary-topic-coverage"]');
      const percentage = Math.round(Number(topic.coverage));
      if (percentage > 0) coverage.textContent = coverageTemplate.replace('{percentage}', String(percentage));
      else coverage.remove();

      fragment.appendChild(node);
    });

    list.appendChild(fragment);
  }

  /**
   * Stamp the reviewer highlights into the drawer body.
   * @param {HTMLElement} root
   * @param {Array<object>} highlights
   * @returns {void}
   */
  function renderReviewsSummaryHighlights(root, highlights) {
    const section = root.querySelector('[data-js="reviews-summary-highlights"]');
    const list = root.querySelector('[data-js="reviews-summary-highlight-list"]');
    const template = root.querySelector('[data-js="reviews-summary-highlight-template"]');
    if (!section || !list || !template || !highlights.length) return;

    const highlightTemplate = root.dataset.highlightTemplate || '';
    const fragment = document.createDocumentFragment();

    highlights.forEach((entry) => {
      const node = template.content.firstElementChild.cloneNode(true);
      node.textContent = highlightTemplate
        .replace('{highlight}', entry.highlight)
        .replace('{name}', entry.reviewerName);
      fragment.appendChild(node);
    });

    list.appendChild(fragment);
    section.hidden = false;
  }

  /**
   * Fill the star bottomline to the average score.
   * @param {HTMLElement} root
   * @param {object} bottomline - A `window.YotpoRatings` rating: { count, average, percentage }.
   * @returns {void}
   */
  function renderReviewsSummaryRating(root, bottomline) {
    const rating = root.querySelector('[data-js="reviews-summary-rating"]');
    if (!rating) return;

    const stars = root.querySelector('[data-js="reviews-summary-stars"]');
    if (stars) stars.style.setProperty('--rating-percentage', bottomline.percentage + '%');

    const score = bottomline.average.toFixed(1);
    const average = root.querySelector('[data-js="reviews-summary-average"]');
    if (average) average.textContent = score;

    const label = root.dataset.ratingTemplate || '';
    if (label) {
      rating.setAttribute('aria-label', label.replace('{score}', score).replace('{count}', String(bottomline.count)));
    }

    rating.hidden = false;
  }

  /**
   * Render the drawer from a summary payload.
   * @param {HTMLElement} root
   * @param {object} data - The `response` object from the Yotpo productData endpoint.
   * @param {object | null} bottomline - The star rating, or null when it could not be resolved.
   * @returns {boolean} True when the drawer has content worth surfacing.
   */
  function renderReviewsSummary(root, data, bottomline) {
    const topics = (data.summaryTopics || []).filter((topic) => topic && topic.displayTopic && topic.summary);
    const highlights = (data.summaryHighlights || []).filter((entry) => entry && entry.highlight && entry.reviewerName);
    if (!topics.length && !highlights.length) return false;

    if (bottomline && bottomline.count > 0) {
      renderReviewsSummaryRating(root, bottomline);

      const intro = root.querySelector('[data-js="reviews-summary-intro"]');
      if (intro) {
        intro.textContent = (root.dataset.introTemplate || '').replace('{count}', String(bottomline.count));
        intro.hidden = false;
      }
    }

    renderReviewsSummaryTopics(root, topics);
    renderReviewsSummaryHighlights(root, highlights);
    return true;
  }

  /**
   * Scroll the page to the Yotpo reviews widget, clearing the sticky header.
   * @returns {void}
   */
  function scrollToReviewsWidget() {
    const widget = document.getElementById('yotpo-reviews-main-widget');
    if (!widget) return;

    const headerHeight =
      parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80;

    window.scrollTo({
      top: widget.getBoundingClientRect().top + window.scrollY - headerHeight,
      behavior: 'smooth',
    });
  }

  /**
   * Wire the footer button: the drawer primitive closes on the click, we scroll once it is gone
   * so the scroll lock has been released.
   * @param {HTMLElement} root
   * @returns {void}
   */
  function bindReviewsSummaryReadAll(root) {
    const drawer = root.closest('[data-js="bottom-drawer"]');
    if (!drawer) return;

    let scrollPending = false;

    drawer.addEventListener('click', (event) => {
      if (event.target.closest('[data-js="reviews-summary-read-all"]')) scrollPending = true;
    });

    drawer.addEventListener('drawer:closed', () => {
      if (!scrollPending) return;
      scrollPending = false;
      scrollToReviewsWidget();
    });
  }

  /**
   * Reveal the view-summary trigger, now that the drawer has something behind it.
   * @returns {void}
   */
  function revealSummaryTrigger() {
    document.querySelectorAll('[data-js="view-reviews-summary"]').forEach((button) => {
      button.removeAttribute('data-hidden');
    });
  }

  /**
   * Populate the review summary drawer, revealing its trigger only once there is something to show.
   * @param {HTMLElement} root
   * @returns {void}
   */
  function initReviewsSummary(root) {
    root.dataset.initialised = 'true';

    const appKey = (window.themeSettings || {}).yotpoAppKey;
    const productId = root.dataset.productId;
    if (!appKey || !productId) return;

    // The bottomline renders server-side from the Yotpo metafield snapshot;
    // absent attributes mean the product has no reviews.
    const prefilledCount = Number(root.dataset.ratingCount || '');
    const prefilledAverage = Number(root.dataset.ratingAverage || '');
    const prefilledPercentage = Number(root.dataset.ratingPercentage || '');
    const rating =
      prefilledCount > 0 && prefilledAverage > 0
        ? {
            count: prefilledCount,
            average: prefilledAverage,
            percentage: prefilledPercentage,
          }
        : null;

    Promise.all([fetchReviewsSummary(appKey, productId), rating]).then(([data, bottomline]) => {
      if (!data || !renderReviewsSummary(root, data, bottomline)) return;

      bindReviewsSummaryReadAll(root);
      revealSummaryTrigger();
    });
  }

  function initReviewsSummaries() {
    document.querySelectorAll('[data-js="reviews-summary"]:not([data-initialised="true"])').forEach(initReviewsSummary);
  }

  document.addEventListener('DOMContentLoaded', initReviewsSummaries);
  document.addEventListener('shopify:section:load', initReviewsSummaries);

  /**
   * Fetch the store's base Yotpo Loyalty points-for-purchases earning rule. Resolves to
   * `{ rewardPoints, goalSpendCents }` or null; never rejects. The public campaigns endpoint
   * is keyed by the loyalty GUID alone, so it is safe to call from the storefront.
   * @param {string} guid - The public Yotpo Loyalty GUID.
   * @returns {Promise<{ rewardPoints: number, goalSpendCents: number } | null>}
   */
  async function fetchLoyaltyBaseRule(guid) {
    const cacheKey = 'yotpo-loyalty-base-rule';

    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey));
      if (cached && cached.guid === guid) return cached.rule;
    } catch (err) {
      // An unreadable cache entry just means we refetch.
    }

    try {
      const url = 'https://loyalty.yotpo.com/api/public/v1/campaigns?guid=' + encodeURIComponent(guid);
      const response = await fetch(url);
      if (!response.ok) return null;

      const campaigns = await response.json();
      // Tier-targeted rules already carry each tier's final rate, so the base rule is the lowest active rate — the one every member starts on; tiers scale it via multiplier.
      const purchase = (Array.isArray(campaigns) ? campaigns : [])
        .filter(
          (campaign) =>
            campaign &&
            campaign.type === 'PointsForPurchasesCampaign' &&
            campaign.active &&
            campaign.reward_points > 0 &&
            campaign.goal_spend_cents > 0
        )
        .sort((a, b) => a.reward_points / a.goal_spend_cents - b.reward_points / b.goal_spend_cents)[0];
      const rule = purchase
        ? { rewardPoints: purchase.reward_points, goalSpendCents: purchase.goal_spend_cents }
        : null;

      try {
        sessionStorage.setItem(cacheKey, JSON.stringify({ guid, rule }));
      } catch (err) {
        // Storage may be blocked or full; the fetched rule still renders this page.
      }

      return rule;
    } catch (err) {
      return null;
    }
  }

  /**
   * Resolve the logged-in customer's VIP tier points multiplier from the public
   * customer_details and tiers endpoints, identified the same way Yotpo's own widgets
   * identify customers — email plus Shopify customer id headers. Resolves to 1 for
   * guests, non-members, and on any failure; never rejects.
   * @param {string} guid - The public Yotpo Loyalty GUID.
   * @param {string | undefined} email - The logged-in customer's email.
   * @param {string | undefined} customerId - The logged-in customer's Shopify id.
   * @returns {Promise<number>}
   */
  async function fetchLoyaltyTierMultiplier(guid, email, customerId) {
    if (!email || !customerId) return 1;

    const cacheKey = 'yotpo-loyalty-tier-multiplier';

    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey));
      if (cached && cached.guid === guid && cached.customerId === customerId) return cached.multiplier;
    } catch (err) {
      // An unreadable cache entry just means we refetch.
    }

    try {
      const base = 'https://loyalty.yotpo.com/api/public/v1/';
      const query = '?guid=' + encodeURIComponent(guid);
      const [detailsResponse, tiersResponse] = await Promise.all([
        fetch(base + 'customer_details' + query, {
          headers: { 'X-CUSTOMER-EMAIL': email, 'X-CUSTOMER-STORE-ACCOUNT-ID': customerId },
        }),
        fetch(base + 'tiers' + query),
      ]);

      let multiplier = 1;
      // A 404 is a definitive "not a member yet" — that resolves to the base rate.
      if (detailsResponse.ok && tiersResponse.ok) {
        const details = await detailsResponse.json();
        const tiers = await tiersResponse.json();
        const tier = Array.isArray(tiers) ? tiers.find((t) => t && t.id === details.vip_tier_id) : null;
        const parsed = tier ? parseFloat(tier.points_multiplier) : 1;
        multiplier = parsed > 0 ? parsed : 1;
      } else if (detailsResponse.status !== 404) {
        return 1;
      }

      try {
        sessionStorage.setItem(cacheKey, JSON.stringify({ guid, customerId, multiplier }));
      } catch (err) {
        // Storage may be blocked or full; the resolved multiplier still renders this page.
      }

      return multiplier;
    } catch (err) {
      return 1;
    }
  }

  /**
   * Reveal how many loyalty points the product earns, mirroring Yotpo's product points
   * widget: whole goal-spend units in the price, times the base rule's reward points,
   * times the customer's VIP tier multiplier (1 for guests and non-members). The line
   * stays hidden when no rule is available or the product earns zero points.
   * @param {HTMLElement} root - The points line element.
   * @returns {void}
   */
  function initLoyaltyPoints(root) {
    root.dataset.initialised = 'true';

    const guid = root.dataset.guid;
    const priceCents = parseInt(root.dataset.priceCents, 10);
    const amount = root.querySelector('[data-js="loyalty-points-amount"]');
    if (!guid || !(priceCents > 0) || !amount) return;

    Promise.all([
      fetchLoyaltyBaseRule(guid),
      fetchLoyaltyTierMultiplier(guid, root.dataset.customerEmail, root.dataset.customerId),
    ]).then(([rule, multiplier]) => {
      if (!rule) return;

      const points = Math.floor(Math.floor(priceCents / rule.goalSpendCents) * rule.rewardPoints * multiplier);
      const template = points === 1 ? root.dataset.labelOne : root.dataset.labelOther;
      if (points < 1 || !template) return;

      amount.textContent = template.replace('[points]', points.toLocaleString());
      root.hidden = false;
    });
  }

  function initLoyaltyPointsLines() {
    document.querySelectorAll('[data-js="loyalty-points"]:not([data-initialised="true"])').forEach(initLoyaltyPoints);
  }

  document.addEventListener('DOMContentLoaded', initLoyaltyPointsLines);
  document.addEventListener('shopify:section:load', initLoyaltyPointsLines);

  let trustResizeBound = false;

  /**
   * Hide any trust badge that will not fit on the single desktop row, keeping the
   * longest run of leading badges that does fit.
   * @param {HTMLElement} container - The trust badge row.
   * @returns {void}
   */
  function fitTrustBadges(container) {
    const badges = Array.from(container.querySelectorAll('.product-info__trust'));
    badges.forEach((badge) => badge.removeAttribute('data-hidden'));

    if (!window.matchMedia('(min-width: 768px)').matches) return;

    const available = container.clientWidth;
    if (!available) return;

    const gap = parseFloat(getComputedStyle(container).columnGap) || 0;
    let used = 0;
    let overflowing = false;

    badges.forEach((badge) => {
      if (!overflowing) {
        const width = badge.getBoundingClientRect().width;
        const total = used === 0 ? width : used + gap + width;

        if (total <= available) {
          used = total;
          return;
        }

        overflowing = true;
      }

      badge.setAttribute('data-hidden', 'true');
    });
  }

  /**
   * Fit every trust badge row on the page and keep it fitted across viewport changes.
   * @returns {void}
   */
  function initTrustBadges() {
    document.querySelectorAll('[data-js="trust-badges"]:not([data-initialised="true"])').forEach((container) => {
      container.dataset.initialised = 'true';
      fitTrustBadges(container);

      // Badge widths are not final until the button webfont has swapped in.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => fitTrustBadges(container));
      }
    });

    if (trustResizeBound) return;
    trustResizeBound = true;

    const refit = () => document.querySelectorAll('[data-js="trust-badges"]').forEach(fitTrustBadges);
    const throttled =
      window.themeUtils && typeof window.themeUtils.throttle === 'function' ? window.themeUtils.throttle(refit) : refit;
    window.addEventListener('resize', throttled);
  }

  document.addEventListener('DOMContentLoaded', initTrustBadges);
  document.addEventListener('shopify:section:load', initTrustBadges);

  /** @type {WeakMap<HTMLElement, InstanceType<typeof window.KlaviyoNotifyMe>>} */
  const notifyMeHandlers = new WeakMap();

  function initSizeSelector() {
    const containers = document.querySelectorAll('[data-js="sticky-size-selector"]');

    containers.forEach((container) => {
      if (container.dataset.sizeInitialised === 'true') return;
      container.dataset.sizeInitialised = 'true';

      const buttons = container.querySelectorAll('[data-js="size-button"]');
      const submitBtn = container.querySelector('[data-js="add-to-cart-button"]');
      const variantInput = container.querySelector('[data-js="variant-id-input"]');

      if (!buttons.length || !submitBtn) return;

      const submitLabel = submitBtn.querySelector('[data-js="add-to-cart-label"]');
      const submitSpinner = submitBtn.querySelector('[data-js="add-to-cart-spinner"]');
      const shopPayBtn = container.querySelector('[data-js="shop-pay-checkout"]');

      /**
       * Mirror the add-to-bag button's disabled state onto the Shop Pay
       * express-checkout link so it cannot be used before a size is chosen.
       * @param {boolean} isDisabled
       * @returns {void}
       */
      function setShopPayDisabled(isDisabled) {
        if (!shopPayBtn) return;
        shopPayBtn.dataset.disabled = isDisabled ? 'true' : 'false';
        shopPayBtn.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
        if (isDisabled) {
          shopPayBtn.setAttribute('tabindex', '-1');
        } else {
          shopPayBtn.removeAttribute('tabindex');
        }
      }

      /**
       * Set the add-to-cart button's visible label, falling back to the
       * button's own textContent if the label span is missing (defensive —
       * the markup should always provide it).
       * @param {string} text
       * @returns {void}
       */
      function setSubmitLabel(text) {
        if (submitLabel) {
          submitLabel.textContent = text || '';
        } else {
          submitBtn.textContent = text || '';
        }
      }

      /**
       * Restore the resting label state after a transient (loading, added,
       * error) state, clearing the spinner and data-state.
       * @param {string} text
       * @returns {void}
       */
      function resetSubmit(text) {
        delete submitBtn.dataset.state;
        if (submitSpinner) submitSpinner.hidden = true;
        if (submitLabel) submitLabel.hidden = false;
        setSubmitLabel(text);
        submitBtn.disabled = false;
      }

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          buttons.forEach((btn) => btn.removeAttribute('data-active'));

          button.setAttribute('data-active', 'true');

          if (button.dataset.available === 'false') {
            resetSubmit(submitBtn.dataset.textNotify);
            submitBtn.dataset.mode = 'notify';
          } else {
            resetSubmit(submitBtn.dataset.textSelected);
            delete submitBtn.dataset.mode;
          }

          setShopPayDisabled(false);

          if (variantInput && button.dataset.variantId) {
            variantInput.value = button.dataset.variantId;
            document.dispatchEvent(
              new CustomEvent('variant:changed', {
                detail: { variantId: button.dataset.variantId },
              })
            );
          }
        });
      });

      const urlVariantId = new URLSearchParams(window.location.search).get('variant');
      const urlVariantButton = urlVariantId
        ? Array.from(buttons).find((btn) => btn.dataset.variantId === urlVariantId)
        : null;

      if (urlVariantButton) {
        urlVariantButton.click();
      } else if (buttons.length === 1) {
        // If there's only one size button, select it automatically
        buttons[0].click();
      }

      submitBtn.addEventListener('click', async (e) => {
        e.preventDefault();

        if (submitBtn.dataset.state === 'unselected' || submitBtn.disabled) {
          return;
        }

        const variantId = variantInput && variantInput.value ? String(variantInput.value).trim() : null;
        if (!variantId) return;

        if (submitBtn.dataset.mode === 'notify') {
          const productTitle = document.querySelector('.product-title')?.textContent || '';
          const productColour = document.querySelector('.product-colour')?.textContent || '';
          const activeSizeBtn = container.querySelector('[data-js="size-button"][data-active="true"]');
          const productSize = activeSizeBtn ? activeSizeBtn.textContent.trim() : '';

          const parts = [productTitle];
          if (productColour) parts.push(productColour);
          if (productSize) parts.push(productSize);
          const notifyTitle = parts.filter(Boolean).join(' · ');

          const otherSoldOutSizes = Array.from(buttons)
            .filter((btn) => btn.dataset.available === 'false' && btn.dataset.variantId !== variantId)
            .map((btn) => ({ id: btn.dataset.variantId, label: btn.textContent.trim() }));

          document.querySelectorAll('.product-notify-me-container [data-js="notify-me"]').forEach((panel) => {
            if (!panel.dataset.initialised) {
              panel.dataset.initialised = 'true';
              if (typeof window.KlaviyoNotifyMe !== 'undefined') {
                try {
                  notifyMeHandlers.set(
                    panel,
                    new window.KlaviyoNotifyMe(panel, {
                      onClose: () => window.BottomDrawer?.close('notify-me-drawer'),
                    })
                  );
                } catch (err) {
                  /* Klaviyo BIS failed to initialise — fail silently */
                }
              }
            }

            const handler = notifyMeHandlers.get(panel);
            if (handler) {
              handler.reset({ keepContact: true });
              handler.setOtherSizes(otherSoldOutSizes);
            }

            const variantInput = panel.querySelector('[data-js="notify-me-variant-id"]');
            const titleEl = panel.querySelector('[data-js="notify-me-product"]');
            if (variantInput) variantInput.value = variantId;
            if (titleEl) titleEl.textContent = notifyTitle;
          });

          window.BottomDrawer?.open('notify-me-drawer');
          return;
        }

        const originalText =
          submitBtn.dataset.textSelected || (submitLabel ? submitLabel.textContent : submitBtn.textContent);
        submitBtn.dataset.state = 'loading';
        submitBtn.disabled = true;
        if (submitLabel) submitLabel.hidden = true;
        if (submitSpinner) submitSpinner.hidden = false;

        try {
          const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1 }],
              sections: 'minicart',
              sections_url: window.location.pathname,
            }),
          });

          const body = await res.json().catch(() => ({}));

          if (!res.ok) {
            submitBtn.dataset.state = 'error';
            if (submitSpinner) submitSpinner.hidden = true;
            if (submitLabel) submitLabel.hidden = false;
            setSubmitLabel(body.description || submitBtn.dataset.textError || 'Error');
            setTimeout(() => {
              resetSubmit(originalText);
            }, 2000);
            return;
          }

          submitBtn.dataset.state = 'added';
          if (submitSpinner) submitSpinner.hidden = true;
          if (submitLabel) submitLabel.hidden = false;
          setSubmitLabel(submitBtn.dataset.textAdded);

          document.dispatchEvent(
            new CustomEvent('cart:added', {
              detail: {
                sections: body.sections || null,
                openMinicart: false,
              },
            })
          );

          setTimeout(() => {
            resetSubmit(originalText);
          }, 2000);
        } catch (err) {
          submitBtn.dataset.state = 'error';
          if (submitSpinner) submitSpinner.hidden = true;
          if (submitLabel) submitLabel.hidden = false;
          setSubmitLabel(submitBtn.dataset.textError || 'Error');
          setTimeout(() => {
            resetSubmit(originalText);
          }, 2000);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initSizeSelector);
  document.addEventListener('shopify:section:load', initSizeSelector);

  function initStickySizeSelector() {
    const selector = document.querySelector('[data-js="sticky-size-selector"]');
    if (!selector || selector.dataset.initialised === 'true') return;

    selector.dataset.initialised = 'true';

    const scrollController = new AbortController();
    const overlayController = new AbortController();

    let ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          if (document.documentElement.classList.contains('lock-scroll')) {
            ticking = false;
            return;
          }

          if (window.scrollY > 50 || selector.dataset.stuck === 'true') {
            selector.setAttribute('data-visible', 'true');
          } else {
            selector.setAttribute('data-visible', 'false');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true, signal: scrollController.signal });
    onScroll();

    document.addEventListener(
      'overlay-show',
      () => {
        const rect = selector.getBoundingClientRect();
        const isStuck = Math.abs(rect.bottom - window.innerHeight) <= 2;

        if (isStuck) {
          selector.setAttribute('data-visible', 'false');
        }
      },
      { signal: overlayController.signal }
    );

    document.addEventListener(
      'overlay-hide',
      () => {
        window.requestAnimationFrame(() => {
          if (window.scrollY > 50 || selector.dataset.stuck === 'true') {
            selector.setAttribute('data-visible', 'true');
          }
        });
      },
      { signal: overlayController.signal }
    );

    const sentinel = document.querySelector('[data-js="sticky-size-sentinel"]');
    const placeholder = document.querySelector('[data-js="sticky-atc-placeholder"]');
    const sectionRoot = selector.closest('.shopify-section');
    const desktopQuery = window.matchMedia('(min-width: 768px)');
    let sectionObserver = null;

    /**
     * Viewport offset the sticky header and announcement bar occupy — the line
     * the inline submit button disappears behind on desktop.
     * @returns {number}
     */
    function headerBottom() {
      const styles = getComputedStyle(document.documentElement);
      const height = parseInt(styles.getPropertyValue('--header-height'), 10) || 80;
      const offset = parseInt(styles.getPropertyValue('--header-offset'), 10) || 0;
      return height + offset;
    }

    /**
     * Pin the selector to the viewport bottom as the desktop sticky bar.
     * @returns {void}
     */
    function stick() {
      if (selector.dataset.stuck === 'true') return;
      const active = document.activeElement;
      const activeInside = active && active !== document.body && selector.contains(active);

      placeholder.style.height = `${selector.offsetHeight}px`;
      placeholder.hidden = false;
      document.body.appendChild(selector);
      selector.dataset.stuck = 'true';

      if (!document.documentElement.classList.contains('lock-scroll')) {
        selector.setAttribute('data-visible', 'true');
      }

      if (activeInside) {
        const target = active.offsetParent === null ? selector.querySelector('button:not(:disabled)') : active;
        if (target) target.focus({ preventScroll: true });
      }
    }

    /**
     * Return the selector to its inline slot in the buy box.
     * @returns {void}
     */
    function unstick() {
      if (selector.dataset.stuck !== 'true') return;
      delete selector.dataset.stuck;
      placeholder.after(selector);
      placeholder.hidden = true;
      placeholder.style.height = '';
    }

    if (sentinel && placeholder && 'IntersectionObserver' in window) {
      const headerLine = headerBottom();

      sectionObserver = new IntersectionObserver(
        (entries) => {
          if (!desktopQuery.matches) return;
          const entry = entries[entries.length - 1];

          if (!entry.isIntersecting) {
            stick();
          } else {
            unstick();
          }
        },
        { rootMargin: `-${headerLine}px 0px 0px 0px` }
      );
      sectionObserver.observe(sentinel);

      desktopQuery.addEventListener(
        'change',
        (event) => {
          if (!event.matches) {
            unstick();
            return;
          }

          const rect = sentinel.getBoundingClientRect();
          if (rect.bottom <= headerBottom() || rect.top >= window.innerHeight) {
            stick();
          } else {
            unstick();
          }
        },
        { signal: scrollController.signal }
      );
    }

    /**
     * Publish the bar's viewport-bottom footprint on the root element so the
     * INSIDE chat tab can seat itself above it (see the #inside_holder
     * override in this section's stylesheet). Cleared whenever the bar is
     * off-screen or inline so the vendor's default position applies.
     * @returns {void}
     */
    function publishChatClearance() {
      const docEl = document.documentElement;
      const pinned = desktopQuery.matches ? selector.dataset.stuck === 'true' : true;

      if (pinned && selector.dataset.visible === 'true') {
        docEl.style.setProperty('--chat-tab-clearance', `${selector.offsetHeight}px`);
        docEl.dataset.chatTabRaised = 'true';
      } else {
        delete docEl.dataset.chatTabRaised;
        docEl.style.removeProperty('--chat-tab-clearance');
      }
    }

    const chatClearanceObserver = new MutationObserver(publishChatClearance);
    chatClearanceObserver.observe(selector, { attributes: true, attributeFilter: ['data-visible', 'data-stuck'] });

    const chatResizeObserver = 'ResizeObserver' in window ? new ResizeObserver(publishChatClearance) : null;
    if (chatResizeObserver) chatResizeObserver.observe(selector);

    desktopQuery.addEventListener('change', publishChatClearance, { signal: scrollController.signal });
    publishChatClearance();

    document.addEventListener(
      'shopify:section:unload',
      (event) => {
        if (sectionRoot && event.target !== sectionRoot) return;
        unstick();
        scrollController.abort();
        overlayController.abort();
        if (sectionObserver) sectionObserver.disconnect();
        chatClearanceObserver.disconnect();
        if (chatResizeObserver) chatResizeObserver.disconnect();
        delete document.documentElement.dataset.chatTabRaised;
        document.documentElement.style.removeProperty('--chat-tab-clearance');
      },
      { signal: overlayController.signal }
    );
  }

  document.addEventListener('DOMContentLoaded', initStickySizeSelector);
  document.addEventListener('shopify:section:load', initStickySizeSelector);

  function initReviewsScroll() {
    const scrollBtns = document.querySelectorAll('[data-js="scroll-to-reviews"]');
    scrollBtns.forEach((btn) => {
      if (btn.dataset.initialised) return;
      btn.dataset.initialised = 'true';

      btn.addEventListener('click', (e) => {
        const widget =
          document.getElementById('yotpo-reviews-main-widget') || document.getElementById('product-reviews');
        if (!widget) return;

        e.preventDefault();
        const headerHeight =
          parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80;
        const targetPos = widget.getBoundingClientRect().top + window.scrollY - headerHeight;

        window.scrollTo({
          top: targetPos,
          behavior: 'smooth',
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initReviewsScroll);
  document.addEventListener('shopify:section:load', initReviewsScroll);

  function initPdpBundle() {
    const bundle = document.querySelector('[data-js="pdp-bundle"]');
    if (!bundle || bundle.dataset.initialised === 'true') return;
    bundle.dataset.initialised = 'true';

    const profileId = bundle.dataset.profileId;
    const format = bundle.dataset.currencyFormat || '${' + '{amount}}';

    // Athos keys a product's cross-sells to its first variant SKU, so the
    // lookup sends every variant SKU rather than the selected one — a
    // sold-out first size or a ?variant= landing would otherwise return
    // nothing.
    let productSkus = [];
    try {
      const parsed = JSON.parse(bundle.dataset.productSkus || '[]');
      if (Array.isArray(parsed)) {
        productSkus = parsed.filter((sku) => typeof sku === 'string' && sku.trim() !== '');
      }
    } catch (_e) {
      productSkus = [];
    }

    if (!profileId) return;

    if (!window.AthosAPI || !window.ProductCardBind || productSkus.length === 0) {
      bundle.hidden = true;
      return;
    }

    // Slim normalise for just what we need in the bundle
    function normalise(r) {
      const core = (r.mappings && r.mappings.core) || {};
      const attrs = r.attributes || {};

      const priceMajor = parseFloat(core.price ?? r.price ?? 0);
      const msrpMajor = parseFloat(core.msrp ?? r.msrp ?? 0);
      const price = Number.isFinite(priceMajor) ? Math.round(priceMajor * 100) : 0;
      const compareAt = Number.isFinite(msrpMajor) ? Math.round(msrpMajor * 100) : 0;
      const onSale = compareAt > 0 && compareAt > price;
      const promo =
        window.PromoPricing && typeof window.PromoPricing.resolve === 'function'
          ? window.PromoPricing.resolve({
              priceCents: price,
              tags: attrs.ss_tags || r.ss_tags,
            })
          : null;

      const imageList =
        (Array.isArray(attrs.ss_images) && attrs.ss_images) ||
        (Array.isArray(r.images) && r.images) ||
        [core.imageUrl || core.thumbnailImageUrl].filter(Boolean);

      const titleParts = (core.name || r.name || r.title || '').split(' - ');
      const title = titleParts[0];
      const colour = titleParts[1] || '';
      const handle = attrs.handle || r.handle || '';
      const productUrl = core.url || r.url || (handle ? `/products/${handle}` : '#');

      // Shopify's auto-generated video posters (/files/preview_images/…)
      // stay in the list: they render as still slides that
      // `assets/product-card-video.js` upgrades to playing video in place.
      const media = imageList.slice(0, 5).map((src) => {
        let imageUrl = src;
        let srcset = '';
        if (imageUrl && imageUrl.includes('cdn.shopify.com')) {
          try {
            const url = new URL(imageUrl, window.location.origin);
            url.pathname = url.pathname.replace(
              /_(?:\d+x\d*(?:_crop_[a-zA-Z]+)?|small|medium|large|grande|original)(\.[a-zA-Z0-9]+)$/i,
              '$1'
            );
            srcset = [400, 600, 800, 1200]
              .map((w) => {
                url.searchParams.set('width', String(w));
                return `${url.toString()} ${w}w`;
              })
              .join(', ');
            url.searchParams.set('width', '800');
            imageUrl = url.toString();
          } catch (e) {}
        }
        return {
          image: imageUrl,
          alt: title,
          width: 200,
          height: 290,
          product_url: productUrl,
          product_title: title,
          is_image: 'true',
          srcset: srcset || undefined,
          sizes_attr: '(max-width: 767px) 47vw, 210px',
        };
      });

      let parsedSizes = [];
      const rawSizes = attrs.ss_sizes || r.ss_sizes;
      if (typeof rawSizes === 'string' && rawSizes) {
        try {
          parsedSizes = JSON.parse(rawSizes.replace(/&quot;/g, '"').replace(/&amp;/g, '&'));
        } catch (e) {
          parsedSizes = [];
        }
      } else if (Array.isArray(rawSizes)) {
        parsedSizes = rawSizes;
      }
      if (!Array.isArray(parsedSizes)) parsedSizes = [];

      if (parsedSizes.length === 0 && r.variants && Array.isArray(r.variants.data)) {
        parsedSizes = r.variants.data.map((v) => {
          return {
            id: v.mappings && v.mappings.core && v.mappings.core.uid ? String(v.mappings.core.uid) : '',
            label: v.options && v.options.size && v.options.size.value ? String(v.options.size.value) : '',
            available: v.mappings && v.mappings.core && v.mappings.core.available ? 1 : 0,
          };
        });
      }

      parsedSizes = parsedSizes.filter((s) => s && s.label);

      let sizeLabel = '';
      if (parsedSizes.length > 0) {
        const firstLabel = String(parsedSizes[0].label || '');
        if (firstLabel && firstLabel !== 'One Size' && firstLabel.includes(' ')) {
          const parts = firstLabel.split(' ');
          parts.pop();
          sizeLabel = parts.join(' ').trim();
        }
      }

      const variants = parsedSizes.map((s) => {
        const label = String(s.label || '');
        let size;
        if (label === 'One Size') {
          size = label;
        } else if (label.includes(' ')) {
          const parts = label.split(' ');
          size = (parts[parts.length - 1] || label).trim();
        } else {
          size = label;
        }
        const available = Number(s.available) > 0;
        return {
          id: String(s.id || ''),
          label,
          size,
          available,
          available_str: available ? 'true' : 'false',
          aria_disabled: available ? undefined : 'true',
          aria_label: label,
        };
      });

      const firstAvailableVariant = variants.find((v) => v.available);
      const firstAvailableVariantId = firstAvailableVariant ? firstAvailableVariant.id : '';

      const { colour_options, colour_overflow } = window.ProductCardBind.parseColourSwatches(
        r,
        handle,
        productUrl,
        colour
      );

      return {
        id: core.uid || r.id || r.product_id || '',
        handle,
        title,
        colour,
        product_url: productUrl,
        product_title: title,
        price,
        compare_at_price: compareAt,
        on_sale: onSale,
        price_type: onSale ? 'discount' : null,
        promo_percent: promo ? promo.percent : 0,
        promo_price: promo ? promo.priceCents : price,
        formatted_promo_price: promo ? window.AthosAPI.formatMoney(promo.priceCents, format, true) : null,
        promo_message: promo
          ? window.PromoPricing.message(window.AthosAPI.formatMoney(promo.priceCents, format, true), promo.percent) ||
            null
          : null,
        formatted_price: window.AthosAPI.formatMoney(price, format, true),
        formatted_compare_at_price: window.AthosAPI.formatMoney(compareAt, format, true),
        media:
          media.length > 0
            ? media
            : [
                {
                  image: '',
                  alt: title,
                  width: 200,
                  height: 290,
                  product_url: productUrl,
                  product_title: title,
                  is_image: 'true',
                },
              ],
        firstAvailableVariantId,
        variants,
        size_label: sizeLabel,
        colour_options,
        colour_overflow,
        swipeable: 'true',
      };
    }

    /**
     * Render size pills into a bundle drawer item's size row.
     * Mirrors the quick-add drawer's pill markup so the two read alike.
     * @param {HTMLElement} container - The size row to fill.
     * @param {Array} variants - Normalised variant objects (id, size, available).
     * @param {string} soldOutLabel - Visually-hidden prefix for unavailable sizes.
     * @returns {void}
     */
    function buildBundleSizePills(container, variants, soldOutLabel) {
      container.textContent = '';
      variants.forEach((variant) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pdp-bundle-drawer__size';
        btn.dataset.js = 'pdp-bundle-size';
        btn.dataset.variantId = String(variant.id);
        btn.dataset.size = variant.size;
        const available = variant.available === true || variant.available_str === 'true';
        btn.dataset.available = String(available);
        btn.setAttribute('aria-pressed', 'false');
        if (!available) {
          // The bundle has no notify-me path, so a sold-out size is a dead
          // end — disable it outright rather than let it look selectable.
          btn.disabled = true;
          if (soldOutLabel) {
            const note = document.createElement('span');
            note.className = 'visually-hidden';
            note.textContent = soldOutLabel + ' ';
            btn.appendChild(note);
          }
        }
        btn.appendChild(document.createTextNode(variant.size));
        container.appendChild(btn);
      });
    }

    window.AthosAPI.fetchRecommend({
      profiles: [profileId],
      products: productSkus,
    })
      .then((profiles) => {
        const profile = profiles && profiles.length > 0 ? profiles[0] : null;
        if (!profile || !profile.results || profile.results.length === 0) {
          bundle.hidden = true;
          return;
        }

        const results = profile.results.slice(0, 2);

        const grid = bundle.querySelector('[data-js="pdp-bundle-grid"]');
        const skeleton = bundle.querySelector('[data-js="pdp-bundle-skeleton"]');
        const template = bundle.querySelector('template[data-js="pdp-bundle-card-template"]');
        const openBtn = bundle.querySelector('[data-js="pdp-bundle-open"]');
        const drawerEl = document.getElementById('pdp-bundle-drawer');
        const confirmBtn = drawerEl ? drawerEl.querySelector('[data-js="pdp-bundle-confirm"]') : null;

        if (!grid || !template || !openBtn || !drawerEl || !confirmBtn) return;

        let combinedPrice = 0;
        const variantIds = [];
        const bundleData = [];

        results.forEach((r) => {
          const data = normalise(r);
          bundleData.push(data);
          combinedPrice += data.price;
          if (data.firstAvailableVariantId) variantIds.push(data.firstAvailableVariantId);

          const card = window.ProductCardBind.renderCard(template, data);
          if (card) grid.appendChild(card);
        });

        // Prepend the current product as the bundle anchor. It renders at the
        // top of the drawer (never in the collapsed grid) and is added to the
        // cart with the recommendations. parentCount offsets the Athos beacon
        // loop, which must stay aligned with `results`.
        let parentCount = 0;
        const parentScript = bundle.querySelector('[data-js="pdp-bundle-parent"]');
        if (parentScript) {
          try {
            const parent = JSON.parse(parentScript.textContent);
            parent.isParent = true;
            parent.media = parent.image
              ? [{ image: parent.image, srcset: parent.srcset || '', alt: parent.title || '' }]
              : [];
            bundleData.unshift(parent);
            combinedPrice += Number(parent.price) || 0;
            parentCount = 1;
          } catch (_e) {}
        }

        const labelTemplate = confirmBtn.dataset.labelTemplate || '';
        const formattedCombinedPrice = window.AthosAPI.formatMoney(combinedPrice, format, true);
        const replacedLabel = labelTemplate.replace('[price]', formattedCombinedPrice);
        const openLabel = openBtn.querySelector('[data-js="pdp-bundle-open-label"]');
        if (openLabel) openLabel.textContent = replacedLabel;

        if (skeleton) skeleton.remove();
        grid.dataset.count = String(results.length);
        grid.hidden = false;

        // Coordinates with the product-card entrance fade defined in
        // product-card.liquid; 700ms covers the longest staggered card delay.
        grid.dataset.cardsResolving = 'true';
        setTimeout(() => {
          delete grid.dataset.cardsResolving;
        }, 700);

        // Only offer the bundle when every card resolved an addable
        // variant — a partial bundle would mislead once opened.
        openBtn.hidden = variantIds.length !== results.length;

        const cards = grid.querySelectorAll('[data-js="product-card"]');
        cards.forEach((card) => {
          const slider = card.querySelector('media-slider');
          if (slider && typeof slider.loadActive === 'function') {
            slider.loadActive();
          } else {
            const firstLazy = card.querySelector('img[data-src], video[data-src]');
            if (firstLazy) {
              if (firstLazy.dataset.srcset) {
                firstLazy.srcset = firstLazy.dataset.srcset;
                delete firstLazy.dataset.srcset;
              }
              firstLazy.src = firstLazy.dataset.src;
              delete firstLazy.dataset.src;
            }
          }
        });

        let bundleCloseTimer;

        /**
         * Build the bundle drawer's product rows, wire per-item size
         * selection, and gate the confirm button until every multi-size
         * product has a chosen size before adding all items to the cart.
         * @returns {void}
         */
        function setupBundleDrawer() {
          const itemsWrap = drawerEl.querySelector('[data-js="pdp-bundle-drawer-items"]');
          const itemTemplate = drawerEl.querySelector('template[data-js="pdp-bundle-drawer-template"]');
          if (!itemsWrap || !itemTemplate) return;

          const confirmLabel = confirmBtn.querySelector('[data-js="pdp-bundle-confirm-label"]');
          const confirmSpinner = confirmBtn.querySelector('[data-js="pdp-bundle-confirm-spinner"]');
          const soldOutLabel = itemsWrap.dataset.labelSoldOut || '';
          const selectSizeLabel = itemsWrap.dataset.selectSizeLabel || '';

          // One slot per product: the chosen variant id, or null while a
          // multi-size product still needs a size. Single-size products are
          // satisfied up front so they never block the confirm.
          const selections = bundleData.map((data) => {
            const only = data.variants.length === 1 ? data.variants[0] : null;
            return only && only.available ? String(only.id) : null;
          });

          function updateConfirmState() {
            if (confirmBtn.dataset.state === 'loading' || confirmBtn.dataset.state === 'added') return;
            if (selections.every(Boolean)) {
              delete confirmBtn.dataset.state;
              confirmBtn.disabled = false;
            } else {
              confirmBtn.dataset.state = 'incomplete';
              confirmBtn.disabled = true;
            }
          }

          bundleData.forEach((data, index) => {
            const frag = itemTemplate.content.cloneNode(true);

            const img = frag.querySelector('[data-js="bundle-item-image"]');
            const media = (data.media && data.media[0]) || null;
            if (img && media && media.image) {
              img.src = media.image;
              if (media.srcset) img.srcset = media.srcset;
              img.alt = data.title || '';
            }

            const link = frag.querySelector('[data-js="bundle-item-link"]');
            if (link) link.href = data.product_url || '#';

            const parentLabelEl = frag.querySelector('[data-js="bundle-item-parent-label"]');
            if (parentLabelEl && data.isParent) {
              parentLabelEl.textContent = itemsWrap.dataset.parentLabel || '';
              parentLabelEl.hidden = false;
            }

            const titleEl = frag.querySelector('[data-js="bundle-item-title"]');
            if (titleEl) titleEl.textContent = data.title || '';
            const colourEl = frag.querySelector('[data-js="bundle-item-colour"]');
            if (colourEl) colourEl.textContent = data.colour || '';
            const priceEl = frag.querySelector('[data-js="bundle-item-price"]');
            if (priceEl) {
              priceEl.textContent = data.formatted_price || '';
              if (data.on_sale) priceEl.dataset.type = 'discount';
            }
            const compareEl = frag.querySelector('[data-js="bundle-item-compare"]');
            if (compareEl && data.on_sale && data.formatted_compare_at_price) {
              compareEl.textContent = data.formatted_compare_at_price;
              compareEl.hidden = false;
            }
            const promoEl = frag.querySelector('[data-js="bundle-item-promo"]');
            if (promoEl && data.promo_message) {
              promoEl.textContent = data.promo_message;
              promoEl.hidden = false;
            }

            const promptEl = frag.querySelector('[data-js="bundle-item-prompt"]');
            const sizesEl = frag.querySelector('[data-js="bundle-item-sizes"]');
            const isSingle = data.variants.length === 1;

            if (sizesEl) {
              sizesEl.setAttribute('aria-label', selectSizeLabel);
              buildBundleSizePills(sizesEl, data.variants, soldOutLabel);
              if (isSingle) sizesEl.dataset.single = 'true';

              sizesEl.addEventListener('click', (event) => {
                const btn = event.target.closest('[data-js="pdp-bundle-size"]');
                if (!btn || btn.dataset.available === 'false') return;
                sizesEl.querySelectorAll('[data-js="pdp-bundle-size"]').forEach((other) => {
                  other.dataset.selected = 'false';
                  other.setAttribute('aria-pressed', 'false');
                });
                btn.dataset.selected = 'true';
                btn.setAttribute('aria-pressed', 'true');
                selections[index] = btn.dataset.variantId;
                updateConfirmState();
              });
            }

            if (promptEl) {
              if (isSingle) {
                promptEl.hidden = true;
              } else {
                promptEl.textContent = selectSizeLabel;
              }
            }

            if (index === bundleData.length - 1) {
              const hrEl = frag.querySelector('hr');
              if (hrEl) hrEl.remove();
            }

            itemsWrap.appendChild(frag);
          });

          function setConfirmLabel(text) {
            if (confirmLabel) confirmLabel.textContent = text || '';
          }

          function resetConfirm() {
            delete confirmBtn.dataset.state;
            if (confirmSpinner) confirmSpinner.hidden = true;
            if (confirmLabel) confirmLabel.hidden = false;
            setConfirmLabel(replacedLabel);
            updateConfirmState();
          }

          setConfirmLabel(replacedLabel);
          updateConfirmState();

          confirmBtn.addEventListener('click', async () => {
            if (confirmBtn.disabled) return;

            const items = selections
              .filter(Boolean)
              .map((id) => ({ id: Number(id), quantity: 1 }))
              .filter((item) => item.id);

            if (items.length !== bundleData.length) {
              updateConfirmState();
              return;
            }

            confirmBtn.dataset.state = 'loading';
            confirmBtn.disabled = true;
            if (confirmLabel) confirmLabel.hidden = true;
            if (confirmSpinner) confirmSpinner.hidden = false;

            try {
              const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({
                  items,
                  sections: 'minicart',
                  sections_url: window.location.pathname,
                }),
              });

              const body = await res.json().catch(() => ({}));

              if (!res.ok) {
                confirmBtn.dataset.state = 'error';
                if (confirmSpinner) confirmSpinner.hidden = true;
                if (confirmLabel) confirmLabel.hidden = false;
                setConfirmLabel(body.description || confirmBtn.dataset.labelError || '');
                setTimeout(resetConfirm, 2000);
                return;
              }

              confirmBtn.dataset.state = 'added';
              if (confirmSpinner) confirmSpinner.hidden = true;
              if (confirmLabel) confirmLabel.hidden = false;
              setConfirmLabel((confirmBtn.dataset.labelAdded || '').replace('[count]', String(items.length)));

              if (window.AthosBeacon && profile.responseId) {
                results.forEach((r, i) => {
                  window.AthosBeacon.sendRecommendAddtocart(profile.tag, profile.responseId, r, {
                    id: Number(selections[i + parentCount]),
                    quantity: 1,
                  });
                });
              }

              document.dispatchEvent(
                new CustomEvent('cart:added', {
                  detail: {
                    sections: body.sections || null,
                    openMinicart: false,
                  },
                })
              );

              // Let the added state read before the sheet dismisses.
              clearTimeout(bundleCloseTimer);
              bundleCloseTimer = setTimeout(() => {
                if (window.BottomDrawer) window.BottomDrawer.close('pdp-bundle-drawer');
              }, 1600);
            } catch (err) {
              confirmBtn.dataset.state = 'error';
              if (confirmSpinner) confirmSpinner.hidden = true;
              if (confirmLabel) confirmLabel.hidden = false;
              setConfirmLabel(confirmBtn.dataset.labelError || '');
              setTimeout(resetConfirm, 2000);
            }
          });

          function rearmConfirm() {
            clearTimeout(bundleCloseTimer);
            const state = confirmBtn.dataset.state;
            if (state === 'added' || state === 'error' || state === 'loading') {
              resetConfirm();
            }
          }

          drawerEl.addEventListener('drawer:closed', rearmConfirm);
          drawerEl.addEventListener('drawer:open', rearmConfirm);
        }

        setupBundleDrawer();

        if (window.AthosBeacon && profile.responseId) {
          window.AthosBeacon.sendRecommendRender(profile.tag, profile.responseId);

          if ('IntersectionObserver' in window) {
            const impressionObserver = new IntersectionObserver(
              (entries, obs) => {
                if (!entries.some((entry) => entry.isIntersecting)) return;
                obs.disconnect();
                window.AthosBeacon.sendRecommendImpression(profile.tag, profile.responseId, results);
              },
              { threshold: 0.5 }
            );
            impressionObserver.observe(grid);
          } else {
            window.AthosBeacon.sendRecommendImpression(profile.tag, profile.responseId, results);
          }

          grid.addEventListener('click', function (e) {
            if (!e.target.closest('a[href]')) return;
            const card = e.target.closest('[data-js="product-card"]');
            if (!card) return;
            const handle = card.getAttribute('data-product-handle');
            const result = results.find(function (r) {
              const rHandle = (r.attributes && r.attributes.handle) || r.handle || '';
              return rHandle === handle;
            });
            if (!result) return;
            window.AthosBeacon.sendRecommendClickthrough(profile.tag, profile.responseId, result);
          });

          grid.addEventListener('quick-add:added', function (e) {
            const card = e.target.closest('[data-js="product-card"]');
            if (!card) return;
            const handle = card.getAttribute('data-product-handle');
            const result = results.find(function (r) {
              const rHandle = (r.attributes && r.attributes.handle) || r.handle || '';
              return rHandle === handle;
            });
            if (!result) return;
            const addedItem = e.detail && e.detail.item ? e.detail.item : null;
            window.AthosBeacon.sendRecommendAddtocart(profile.tag, profile.responseId, result, addedItem);
          });
        }
      })
      .catch(() => {
        bundle.hidden = true;
      });
  }

  document.addEventListener('DOMContentLoaded', initPdpBundle);
  document.addEventListener('shopify:section:load', initPdpBundle);

  /**
   * Initialise cursor-following hover zoom on the desktop image grid.
   * @param {HTMLElement} grid - The desktop gallery grid element.
   * @returns {void}
   */
  function initialiseImageZoom(grid) {
    grid.dataset.initialised = 'true';
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    let zoomed = null;
    let pointerX = 0;
    let pointerY = 0;
    let frame = null;

    /**
     * Move the zoom origin of the hovered image to the cursor position.
     * Clamped to the image box so the scaled render always covers its container.
     * @returns {void}
     */
    function applyOrigin() {
      frame = null;
      if (!zoomed) return;
      const rect = zoomed.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const x = Math.min(Math.max(((pointerX - rect.left) / rect.width) * 100, 0), 100);
      const y = Math.min(Math.max(((pointerY - rect.top) / rect.height) * 100, 0), 100);
      zoomed.style.setProperty('--zoom-origin-x', `${x}%`);
      zoomed.style.setProperty('--zoom-origin-y', `${y}%`);
    }

    /**
     * Release the currently zoomed image, if any.
     * @returns {void}
     */
    function clearZoom() {
      if (!zoomed) return;
      zoomed.dataset.zoomed = 'false';
      zoomed = null;
    }

    grid.addEventListener('pointermove', (event) => {
      if (event.pointerType !== 'mouse') return;
      pointerX = event.clientX;
      pointerY = event.clientY;
      const image = event.target.closest('.image.product-image');
      if (image !== zoomed) {
        clearZoom();
        if (!image) return;
        zoomed = image;
        // Seat the origin under the cursor before the scale transition starts,
        // otherwise the first frame zooms from the stale (or centre) origin.
        applyOrigin();
        image.dataset.zoomed = 'true';
      } else if (zoomed && frame === null) {
        frame = requestAnimationFrame(applyOrigin);
      }
    });

    grid.addEventListener('pointerleave', clearZoom);
  }

  document.querySelectorAll('[data-js="image-zoom"]:not([data-initialised="true"])').forEach(initialiseImageZoom);

  /**
   * Seat a media item at the top of the gallery viewer's scrolling body.
   * @param {HTMLElement} body - The gallery drawer's scrolling body.
   * @param {string} index - The media index to show.
   * @returns {void}
   */
  function scrollGalleryTo(body, index) {
    const item = body.querySelector(`[data-js="gallery-item"][data-media-index="${index}"]`);
    if (!item) return;
    body.scrollTop = item.getBoundingClientRect().top - body.getBoundingClientRect().top + body.scrollTop;
  }

  /**
   * Open the full-screen gallery viewer at a media item.
   * The scroll jump happens synchronously after open(): showModal() has already
   * laid the dialog out, and the sheet is still off-screen, so it is never seen.
   * @param {string} index - The media index to open at.
   * @returns {void}
   */
  function openProductGallery(index) {
    const drawer = document.getElementById('product-gallery-drawer');
    const body = drawer ? drawer.querySelector('.bottom-drawer__body') : null;
    if (!body || !window.BottomDrawer || typeof window.BottomDrawer.open !== 'function') return;
    window.BottomDrawer.open(drawer);
    scrollGalleryTo(body, index);
  }

  /**
   * Initialise click-to-expand on the desktop image grid.
   * @param {HTMLElement} gallery - The desktop gallery element.
   * @returns {void}
   */
  function initialiseDesktopGallery(gallery) {
    gallery.dataset.initialised = 'true';

    gallery.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-js="gallery-open"]');
      if (!trigger) return;
      openProductGallery(trigger.dataset.mediaIndex);
    });

    gallery.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const trigger = event.target.closest('[data-js="gallery-open"]');
      if (!trigger) return;
      event.preventDefault();
      openProductGallery(trigger.dataset.mediaIndex);
    });
  }

  document
    .querySelectorAll('[data-js="desktop-gallery"]:not([data-initialised="true"])')
    .forEach(initialiseDesktopGallery);

  /**
   * Initialise the gallery viewer's desktop thumbnail rail: a thumbnail jumps
   * to its media item, the item in view is marked active, and clicking an
   * image closes the viewer.
   * @param {HTMLElement} thumbs - The thumbnail list inside the gallery drawer.
   * @returns {void}
   */
  function initialiseGalleryThumbs(thumbs) {
    thumbs.dataset.initialised = 'true';
    const drawer = thumbs.closest('[data-js="bottom-drawer"]');
    const body = thumbs.closest('.bottom-drawer__body');
    if (!drawer || !body) return;
    const desktop = window.matchMedia('(min-width: 768px)');

    /**
     * Mark the thumbnail for a media item as active.
     * @param {string} index - The media index in view.
     * @returns {void}
     */
    function setActive(index) {
      thumbs.querySelectorAll('[data-js="gallery-thumb"]').forEach((thumb) => {
        const active = thumb.dataset.mediaIndex === index;
        thumb.dataset.active = String(active);
        if (active) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    // A zero-height band across the middle of the viewport: the item crossing
    // it is the one in view, whatever the image heights.
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.find((entry) => entry.isIntersecting);
        if (visible) setActive(visible.target.dataset.mediaIndex);
      },
      { root: body, rootMargin: '-50% 0px -50% 0px' }
    );
    body.querySelectorAll('[data-js="gallery-item"]').forEach((item) => observer.observe(item));

    body.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-js="gallery-thumb"]');
      if (thumb) {
        scrollGalleryTo(body, thumb.dataset.mediaIndex);
        setActive(thumb.dataset.mediaIndex);
        return;
      }
      if (!desktop.matches || !event.target.closest('[data-js="gallery-item"]')) return;
      if (!window.BottomDrawer || typeof window.BottomDrawer.close !== 'function') return;
      window.BottomDrawer.close(drawer);
    });
  }

  document
    .querySelectorAll('[data-js="gallery-thumbs"]:not([data-initialised="true"])')
    .forEach(initialiseGalleryThumbs);

  /**
   * Initialise tap-to-expand on the mobile gallery slider: a tap on a slide
   * opens the full-screen stacked viewer scrolled to that media item.
   * @param {HTMLElement} slider - The mobile media-slider element.
   * @returns {void}
   */
  function initialiseMobileGallery(slider) {
    slider.dataset.initialised = 'true';

    /**
     * Keep only the visible slide's trigger in the tab order: the slider marks
     * off-screen slides aria-hidden, and a focusable element inside one is an
     * accessibility violation.
     * @returns {void}
     */
    function syncTabStops() {
      slider.querySelectorAll('[data-js="gallery-open"]').forEach((trigger) => {
        trigger.tabIndex = trigger.closest('[aria-hidden="true"]') ? -1 : 0;
      });
    }

    const track = slider.querySelector('[data-js="media-slider-track"]');
    if (track) {
      new MutationObserver(syncTabStops).observe(track, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
        childList: true,
        subtree: true,
      });
      syncTabStops();
    }

    // Post-drag clicks never reach this listener: the slider suppresses them in
    // the capture phase, so only a genuine tap opens the viewer.
    slider.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-js="gallery-open"]');
      if (!trigger) return;
      openProductGallery(trigger.dataset.mediaIndex);
    });

    slider.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const trigger = event.target.closest('[data-js="gallery-open"]');
      if (!trigger) return;
      event.preventDefault();
      openProductGallery(trigger.dataset.mediaIndex);
    });
  }

  document
    .querySelectorAll('[data-js="mobile-gallery"]:not([data-initialised="true"])')
    .forEach(initialiseMobileGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
  /**
   * Initialise a promo banner: stop the autoplaying media for users who
   * prefer reduced motion, leaving the poster still (or the paused first
   * frame) in place.
   * @param {HTMLElement} root - The banner root element.
   * @returns {void}
   */
  function initialisePromoBanner(root) {
    root.dataset.initialised = 'true';
    if (!window.themeUtils || !window.themeUtils.prefersReducedMotion) return;
    root.querySelectorAll('video').forEach((video) => {
      video.removeAttribute('autoplay');
      video.pause();
    });
  }

  document.querySelectorAll('[data-js="promo-banner"]:not([data-initialised="true"])').forEach(initialisePromoBanner);

  /**
   * Flag the document while a cross-document view transition captures the
   * outgoing page so poster stills can stand in for playing videos, which
   * WebKit would otherwise snapshot as blank white regions. Set on
   * `pageswap` (just before the snapshot) and cleared on `pagehide` so a
   * page restored from the back/forward cache never keeps the poster.
   * @returns {void}
   */
  (function bindPromoBannerTransitionCapture() {
    if (window.__promoBannerTransitionCaptureBound) return;
    window.__promoBannerTransitionCaptureBound = true;

    window.addEventListener('pageswap', (event) => {
      if (event.viewTransition) {
        document.documentElement.setAttribute('data-vt-capture', '');
      }
    });

    window.addEventListener('pagehide', () => {
      document.documentElement.removeAttribute('data-vt-capture');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc"]) return;
  try {
    
  (function () {
    /**
     * Whether Yotpo has rendered visible content into the widget container.
     * @param {HTMLElement} widget - The Yotpo widget container.
     * @returns {boolean}
     */
    const hasRendered = (widget) => {
      if (widget.classList.contains('yotpo-display-none') || widget.classList.contains('yotpo-hidden')) {
        return false;
      }
      if (window.getComputedStyle(widget).display === 'none') return false;
      // The widget stretches to the skeleton's grid row, so its own height proves
      // nothing. Look for a child that has laid out instead — Yotpo's first child
      // can be a zero-height wrapper or an injected <style> long before the
      // gallery exists.
      return Array.from(widget.children).some((child) => child.getBoundingClientRect().height > 0);
    };

    /**
     * Initialise a UGC section: reveal the Yotpo gallery once it has rendered,
     * or hide the section if it never does.
     * @param {HTMLElement} section - The section root element.
     * @returns {void}
     */
    const initialiseUgcSection = (section) => {
      section.setAttribute('data-initialised', 'true');

      const skeleton = section.querySelector('[data-js="ugc-skeleton"]');
      const widget = section.querySelector('[data-js="ugc-widget"]');

      if (!skeleton || !widget) return;

      let giveUpTimeout = null;
      let settled = false;

      /** @returns {void} */
      const hideSection = () => {
        section.setAttribute('data-hidden', 'true');
      };

      /** @returns {void} */
      const revealWidget = () => {
        skeleton.setAttribute('data-hidden', 'true');
        // Matches the skeleton's 0.8s opacity transition in the stylesheet.
        setTimeout(() => {
          skeleton.style.display = 'none';
        }, 800);
      };

      /**
       * Poll until Yotpo's gallery has laid out, then swap skeleton for widget.
       * @returns {void}
       */
      const watchForRender = () => {
        let attempts = 0;

        const interval = setInterval(() => {
          attempts++;

          if (hasRendered(widget)) {
            clearInterval(interval);
            revealWidget();
          } else if (attempts >= 100) {
            clearInterval(interval);
            hideSection();
          }
        }, 100);
      };

      /** @returns {void} */
      const checkLoaded = () => {
        if (settled) return;
        if (widget.getAttribute('data-yotpo-element-loaded') !== 'true') return;

        settled = true;
        clearTimeout(giveUpTimeout);
        observer.disconnect();
        watchForRender();
      };

      const observer = new MutationObserver(checkLoaded);

      observer.observe(widget, { attributes: true, attributeFilter: ['data-yotpo-element-loaded'] });

      // Yotpo's loader runs from the head and may have stamped the widget before this ran.
      checkLoaded();

      // Yotpo only builds the gallery once it nears the viewport, so the give-up
      // timer must not start while the section is still far below it.
      const visibility = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          visibility.disconnect();
          if (settled) return;

          giveUpTimeout = setTimeout(hideSection, 10000);
        },
        { rootMargin: '200px' }
      );

      visibility.observe(section);
    };

    const initUgc = () => {
      document.querySelectorAll('[data-js="ugc"]:not([data-initialised="true"])').forEach(initialiseUgcSection);
    };

    const initUgcLayout = () => {
      const ugcElements = document.querySelectorAll('.section--ugc:not([data-layout-initialised="true"])');
      const productInfo = document.querySelector('.product-info-container');

      if (!productInfo || !ugcElements.length) return;

      const mql = window.matchMedia('(min-width: 768px)');

      ugcElements.forEach((section) => {
        section.setAttribute('data-layout-initialised', 'true');

        let placeholderId = `placeholder-${section.id}`;
        let placeholder = document.getElementById(placeholderId);

        if (!placeholder) {
          placeholder = document.createElement('div');
          placeholder.id = placeholderId;
          placeholder.style.display = 'none';
          section.parentNode.insertBefore(placeholder, section);
        }

        const handleLayoutChange = (e) => {
          if (e.matches) {
            if (section.parentNode !== productInfo) {
              productInfo.appendChild(section);
            }
          } else {
            if (section.parentNode !== placeholder.parentNode) {
              placeholder.parentNode.insertBefore(section, placeholder);
            }
          }
        };

        mql.addEventListener('change', handleLayoutChange);
        handleLayoutChange(mql);
      });
    };

    const initAll = () => {
      initUgc();
      initUgcLayout();
    };

    document.addEventListener('DOMContentLoaded', initAll);
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
